const ON_CHANGE_DEBOUNCE_TIMER = 300,
  currentDate = new Date(),
  PUB_SUB_EVENTS = {
    cartUpdate: "cart-update",
    quantityUpdate: "quantity-update",
    optionValueSelectionChange: "option-value-selection-change",
    variantChange: "variant-change",
    cartError: "cart-error"
  };
let subscribers = {};
function subscribe($, t) {
  return void 0 === subscribers[$] && (subscribers[$] = []), subscribers[$] = [...subscribers[$], t], function x() {
    subscribers[$] = subscribers[$].filter($ => $ !== t);
  };
}
function publish($, t) {
  subscribers[$] && subscribers[$].forEach($ => {
    $(t);
  });
}
const GIFTS_LOCAL_STORAGE_KEY = "shrine_gift_goals";
let shouldCheckShrineGifts = !1,
  giftsToMonitor = [];
function initShrineGiftsCheck($ = !1) {
  let x = document.querySelector("cart-drawer-items") || document.querySelector("cart-items");
  if ($ && (x = document.querySelector("cart-items")), !x || x.dataset.giftsStorage !== "true") return;
  let e = localStorage.getItem(GIFTS_LOCAL_STORAGE_KEY);
  if (!e) return;
  let i = JSON.parse(e);
  i && typeof i === "object" && (Object.values(i).forEach($ => {
    let i = x.querySelector(".cart-item--product-" + $.gift_handle);
    if (!i) return;
    let s = document.querySelector(".gift--product-" + $.gift_handle);
    s || (shouldCheckShrineGifts = !0, giftsToMonitor.push($));
  }), updateGiftStyles(), checkShrineGifts($));
}
function updateGiftStyles() {
  let t = document.getElementById("shrine-gifts-style");
  if (t && t.remove(), !giftsToMonitor.length) return;
  let x = document.createElement("style");
  x.id = "shrine-gifts-style";
  let e = giftsToMonitor.map(t => ".cart-item--product-" + t.gift_handle + " .quantity { display: none !important; }").join("\n");
  x.textContent = e, document.head.appendChild(x);
}
function checkShrineGifts($ = !1) {
  let x = document.querySelector("cart-drawer-items") || document.querySelector("cart-items");
  if ($ && (x = document.querySelector("cart-items")), shouldCheckShrineGifts && x && x.updateQuantity) for (let e of giftsToMonitor) {
    let i = x.querySelector(".cart-item--product-" + e.gift_handle);
    if (!i) {
      let s = giftsToMonitor.findIndex($ => $.gift_handle === e.gift_handle);
      s > -1 && giftsToMonitor.splice(s, 1), removeLocalStorageGift(e);
      continue;
    }
    let a = !1;
    if ("product_quantity" === e.type) {
      let r = 0;
      x.querySelectorAll(".cart-item--product-" + e.unlock_product_handle).forEach($ => {
        r += parseInt($.dataset.quantity);
      }), r < parseInt(e.required_quantity) && (a = !0);
    } else if (e.type === "product_variant") {
      let n = x.querySelectorAll(".cart-item--product-" + e.unlock_product_handle);
      if (n.length) {
        let l = Array.isArray(e.valid_variants) ? e.valid_variants : [],
          h = !1,
          c = !1;
        n.forEach($ => {
          let e = $.dataset.variantOptions;
          if (e) {
            c = !0;
            let i = e.split("|||").map($ => $.trim().toLowerCase());
            i.some($ => l.includes($)) && (h = !0);
          }
        }), c && !h && (a = !0);
      } else a = !0;
    } else {
      let d = parseInt(x.dataset.subtotal);
      d < parseInt(e.required_quantity) && (a = !0);
    }
    if (a) {
      let o = giftsToMonitor.findIndex($ => $.gift_handle === e.gift_handle);
      o > -1 && giftsToMonitor.splice(o, 1), removeLocalStorageGift(e);
      let f = i.dataset.index ?? i.id.replace("CartItem-", "");
      x.updateQuantity(f, 0);
      return;
    }
  }
}
function validateSingleQuantityCartItems($, t) {
  for (let [e, i] of Object.entries(t)) {
    let s = $.querySelectorAll(".cart-item--product-" + e);
    if (0 !== s.length) {
      if (s.length > 1) {
        let a = null,
          r = [];
        if (s.forEach($ => {
          let e = $.querySelector("[data-quantity-variant-id]"),
            s = e ? e.dataset.quantityVariantId : null;
          s !== i || a ? r.push($) : a = $;
        }), !a && r.length > 0 && (a = r.shift()), r.length > 0) {
          let n = r[0],
            l = n.dataset.index ?? n.id.replace("CartItem-", "").replace("CartDrawer-Item-", "");
          return $.updateQuantity(l, 0), !0;
        }
      }
      if (1 === s.length) {
        let h = s[0],
          c = parseInt(h.dataset.quantity) || 1;
        if (c > 1) {
          let d = h.dataset.index ?? h.id.replace("CartItem-", "").replace("CartDrawer-Item-", "");
          return $.updateQuantity(d, 1), !0;
        }
      }
    }
  }
  return !1;
}
function validateCartGifts($ = !1) {
  let x = document.querySelector("cart-drawer");
  if (!x) return;
  let e = document.querySelector("cart-drawer-items") || document.querySelector("cart-items");
  if ($ && (e = document.querySelector("cart-items")), !e || !e.updateQuantity) return;
  let i = x.querySelectorAll("cart-drawer-gift"),
    s = x.querySelectorAll('cart-drawer-upsell[data-toggle="true"]');
  if (!i.length && !s.length) return;
  let a = {};
  i.forEach($ => {
    $.dataset.handle && $.dataset.id && "true" === $.dataset.selected && (a[$.dataset.handle] = $.dataset.id);
  });
  let r = {};
  if (s.forEach($ => {
    $.dataset.handle && $.dataset.id && $.dataset.selected === "true" && (r[$.dataset.handle] = $.dataset.id);
  }), !validateSingleQuantityCartItems(e, a) && validateSingleQuantityCartItems(e, r)) return;
}
function removeLocalStorageGift($) {
  let t = localStorage.getItem(GIFTS_LOCAL_STORAGE_KEY);
  if (t) try {
    let x = JSON.parse(t);
    x && x[$.gift_handle] && (delete x[$.gift_handle], localStorage.setItem(GIFTS_LOCAL_STORAGE_KEY, JSON.stringify(x)));
  } catch (e) {
    console.warn("Error parsing gift localStorage data:", e);
  }
}
class CartRemoveButton extends HTMLElement {
  constructor() {
    super(), this.addEventListener("click", t => {
      if (t.preventDefault(), this.dataset.handle) {
        let e = this.dataset.handle,
          i = document.querySelectorAll('.quantity-break__upsell[data-handle="' + e + '"]');
        i.forEach($ => {
          $.dataset.selected = "false", $.classList.remove("quantity-break__upsell--selected");
          let e = $.querySelector("input[type=\"checkbox\"]");
          e && (e.checked = !1);
        });
      }
      let s = this.closest("cart-items") || this.closest("cart-drawer-items");
      this.clearCart ? s.clearCart() : s.updateQuantity(this.dataset.index, 0);
    });
  }
}
customElements.define("cart-remove-button", CartRemoveButton);
class CartItems extends HTMLElement {
  constructor() {
    super(), this.lineItemStatusElement = document.getElementById("shopping-cart-line-item-status") || document.getElementById("CartDrawer-LineItemStatus"), this.secondCartItems = document.querySelector("cart-drawer-items"), this.quantityGifts = document.querySelector(".quantity-gifts");
    let t = debounce(t => {
      this.onChange(t);
    }, 300);
    this.addEventListener("change", t.bind(this)), this.isCartPage = this.nodeName === "CART-ITEMS", this.otherCartItemsSelector = this.isCartPage ? "cart-drawer-items" : "cart-items", this.hasOtherCartItems = null !== document.querySelector(this.otherCartItemsSelector), this.hasOtherCartItems ? this.isCartPage && initShrineGiftsCheck(!0) : initShrineGiftsCheck(!1);
  }
  cartUpdateUnsubscriber = void 0;
  ["connectedCallback"]() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, t => {
      t.source !== "cart-items" && this.onCartUpdate();
    });
  }
  disconnectedCallback() {
    this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber();
  }
  onChange($) {
    this.updateQuantity($.target.dataset.index, $.target.value, document.activeElement.getAttribute("name"));
  }
  ["onCartUpdate"]() {
    window.GiftsboxlySecurity.request("/cart?section_id=main-cart-items").then(t => t.text()).then(t => {
      let e = new DOMParser().parseFromString(window.GiftsboxlySecurity.sanitizeHTML(t), "text/html"),
        i = e.querySelector("cart-items");
      window.GiftsboxlySecurity.writeHTML(this, i.innerHTML, false);
    })["catch"](t => {
      console.error(t);
    });
  }
  ["updateCart"]() {
    let t = JSON.stringify({
      sections: this.getSectionsToRender().map(t => t.section),
      sections_url: window.location.pathname
    });
    window.GiftsboxlySecurity.request("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: t
    }).then(t => t.json()).then(t => {
      this.classList.toggle("is-empty", 0 === t.item_count), this.getSectionsToRender().forEach($ => {
        let i = document.getElementById($.id).querySelector($.selector) || document.getElementById($.id);
        window.GiftsboxlySecurity.writeHTML(i, this.getSectionInnerHTML(t.sections[$.section], $.selector), false);
      });
    })["catch"](t => {
      console.error(t);
    });
  }
  ["getSectionsToRender"]() {
    return [{
      id: "main-cart-items",
      section: document.getElementById("main-cart-items").dataset.id,
      selector: ".js-contents"
    }, {
      id: "cart-icon-bubble",
      section: "cart-icon-bubble",
      selector: ".shopify-section"
    }, {
      id: "cart-live-region-text",
      section: "cart-live-region-text",
      selector: ".shopify-section"
    }, {
      id: "main-cart-footer",
      section: document.getElementById("main-cart-footer").dataset.id,
      selector: ".js-contents"
    }];
  }
  async ["updateQuantity"]($, t, x) {
    this.enableLoading($);
    let i = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
    i && (i.textContent = "");
    let s = JSON.stringify({
      line: $,
      quantity: t,
      sections: this.getSectionsToRender().map($ => $.section),
      sections_url: window.location.pathname
    });
    try {
      let a = await window.GiftsboxlySecurity.request("" + routes.cart_change_url, {
          ...fetchConfig(),
          body: s
        }),
        r = await a.text(),
        n = JSON.parse(r),
        l = document.getElementById("Quantity-" + $) || document.getElementById("Drawer-quantity-" + $),
        h = document.querySelectorAll(".cart-item");
      if (n.errors) {
        l.value = l.getAttribute("value"), this.updateLiveRegions($, n.errors);
        return;
      }
      if (!n.sections) {
        let c = await window.GiftsboxlySecurity.request(routes.cart_url + "?sections=" + this.getSectionsToRender().map($ => $.section).join(","));
        n.sections = await c.json();
      }
      this.classList.toggle("is-empty", 0 === n.item_count);
      let d = document.querySelector("cart-drawer"),
        o = document.getElementById("main-cart-footer");
      o && o.classList.toggle("is-empty", 0 === n.item_count), d && d.classList.toggle("is-empty", 0 === n.item_count), this.getSectionsToRender().forEach($ => {
        let x = document.getElementById($.id);
        if (x) {
          let i = x.querySelector($.selector) || x;
          window.GiftsboxlySecurity.writeHTML(i, this.getSectionInnerHTML(n.sections[$.section], $.selector), false);
          let s = i.querySelector(".cart-drawer__body");
          s && this.cartDrawer && (s.scrollTop = this.cartDrawer.cartBodyScroll);
        }
      });
      let f = n.items[$ - 1] ? n.items[$ - 1].quantity : void 0,
        u = "";
      h.length === n.items.length && f !== parseInt(l.value) && (u = typeof f === "undefined" ? window.cartStrings.error : window.cartStrings.quantityError.replace("[quantity]", f)), this.updateLiveRegions($, u);
      let b = document.getElementById("CartItem-" + $) || document.getElementById("CartDrawer-Item-" + $);
      if (b && b.querySelector("[name=\"" + x + '"]') ? d ? trapFocus(d, b.querySelector("[name=\"" + x + '"]')) : b.querySelector("[name=\"" + x + '"]').focus() : 0 === n.item_count && d ? trapFocus(d.querySelector(".drawer__inner-empty"), d.querySelector("a")) : document.querySelector(".cart-item") && d && trapFocus(d, document.querySelector(".cart-item__name")), d) {
        d.checkForClear();
        let p = d.querySelector("countdown-timer");
        p && p.playTimer();
        let _ = !1;
        if (d.querySelector("cart-drawer-gift")) {
          d.checkForClear();
          let m = [],
            y = [];
          d.querySelectorAll("cart-drawer-gift").forEach($ => {
            $.getUpdateRequired() && (d.querySelector(".cart-item--product-" + $.dataset.handle) ? "false" === $.dataset.selected && y.push($) : "true" === $.dataset.selected && m.push($));
          }), y.length > 0 ? (_ = !0, y[0].removeFromCart()) : m.length > 0 && (_ = !0, m[0].addToCart());
        }
        this.quantityGifts && !_ && this.quantityGifts.initUnlock();
        let g = document.querySelectorAll("quantity-break-upsells");
        g.forEach($ => {
          _ || $.initUnlock();
        });
      }
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: "cart-items",
        cartData: n
      });
    } catch (v) {
      console.log(v), this.querySelectorAll(".loading-overlay").forEach($ => $.classList.add("hidden"));
      let S = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
      S.textContent = window.cartStrings.error;
    } finally {
      this.disableLoading($), this.secondCartItems && this.secondCartItems.updateCart && this.secondCartItems.updateCart();
      let k = new CustomEvent("cartQuantityUpdated", {
        detail: {
          handle: "handle"
        }
      });
      document.dispatchEvent(k), shouldCheckShrineGifts && checkShrineGifts(this.isCartPage), validateCartGifts(this.isCartPage);
    }
  }
  ["updateLiveRegions"]($, t) {
    let e = document.getElementById("Line-item-error-" + $) || document.getElementById("CartDrawer-LineItemError-" + $);
    e && window.GiftsboxlySecurity.writeHTML(e.querySelector(".cart-item__error-text"), t, false), this.lineItemStatusElement.setAttribute("aria-hidden", !0);
    let i = document.getElementById("cart-live-region-text") || document.getElementById("CartDrawer-LiveRegionText");
    i.setAttribute("aria-hidden", !1), setTimeout(() => {
      i.setAttribute("aria-hidden", !0);
    }, 1e3);
  }
  getSectionInnerHTML($, t) {
    return new DOMParser().parseFromString(window.GiftsboxlySecurity.sanitizeHTML($), "text/html").querySelector(t).innerHTML;
  }
  enableLoading($) {
    let x = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
    x.classList.add("cart__items--disabled");
    let e = this.querySelectorAll("#CartItem-" + $ + " .loading-overlay"),
      i = this.querySelectorAll("#CartDrawer-Item-" + $ + " .loading-overlay");
    [...e, ...i].forEach($ => $.classList.remove("hidden")), document.activeElement.blur(), this.lineItemStatusElement.setAttribute("aria-hidden", !1);
  }
  ["disableLoading"]($) {
    let x = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
    x.classList.remove("cart__items--disabled");
    let e = this.querySelectorAll("#CartItem-" + $ + " .loading-overlay"),
      i = this.querySelectorAll("#CartDrawer-Item-" + $ + " .loading-overlay");
    e.forEach($ => $.classList.add("hidden")), i.forEach($ => $.classList.add("hidden"));
  }
  ["clearCart"]() {
    let t = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
    t && (t.textContent = "");
    let x = JSON.stringify({
      sections: this.getSectionsToRender().map(t => t.section),
      sections_url: window.location.pathname
    });
    window.GiftsboxlySecurity.request("" + routes.cart_clear_url, {
      ...fetchConfig(),
      body: x
    }).then(t => t.text()).then(async t => {
      let e = JSON.parse(t);
      if (!e.sections) try {
        let i = this.getSectionsToRender().map($ => $.id).join(","),
          s = await window.GiftsboxlySecurity.request(routes.cart_url + "?sections=" + i),
          a = await s.json();
        e.sections = a;
      } catch (r) {
        throw console.error("Clear cart fallback failed", r), r;
      }
      this.classList.add("is-empty");
      let n = document.querySelector("cart-drawer"),
        l = document.getElementById("main-cart-footer");
      l && l.classList.add("is-empty"), n && n.classList.add("is-empty"), this.getSectionsToRender().forEach($ => {
        let i = document.getElementById($.id).querySelector($.selector) || document.getElementById($.id);
        window.GiftsboxlySecurity.writeHTML(i, this.getSectionInnerHTML(e.sections[$.section], $.selector), false);
      }), n && trapFocus(n.querySelector(".drawer__inner-empty"), n.querySelector("a")), publish(PUB_SUB_EVENTS.cartUpdate, {
        source: "cart-items"
      }), shouldCheckShrineGifts && checkShrineGifts(this.isCartPage);
    }).catch(() => {
      this.querySelectorAll(".loading-overlay").forEach($ => $.classList.add("hidden"));
      let x = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
      x.textContent = window.cartStrings.error;
    });
  }
}
customElements.define("cart-items", CartItems);
var search = "search";
function handleDiscountForm($) {
  $.preventDefault();
  let x = $.target.querySelector("[name=cart-discount-field]"),
    e = $.target.querySelector(".cart-discount-form__error"),
    i = x.value;
  if (void 0 === i || 0 === i.length) {
    e.style.display = "block";
    return;
  }
  e.style.display = "none";
  let s = "/checkout?discount=";
  window.GiftsboxlySecurity.navigate(s + encodeURIComponent(i));
}
function handleDiscountFormChange($) {
  let x = document.querySelectorAll(".cart-discount-form__error");
  x.forEach($ => {
    $.style.display = "none";
  });
}
customElements.get("cart-note") || customElements.define("cart-note", class $ extends HTMLElement {
  constructor() {
    super(), this.addEventListener("change", debounce(t => {
      let e = JSON.stringify({
        note: t.target.value
      });
      window.GiftsboxlySecurity.request("" + routes.cart_update_url, {
        ...fetchConfig(),
        body: e
      });
    }, 300));
  }
});
class SearchForm extends HTMLElement {
  constructor() {
    super(), this.input = this.querySelector("input[type=\"search\"]"), this.resetButton = this.querySelector("button[type=\"reset\"]"), this.input && (this.input.form.addEventListener("reset", this.onFormReset.bind(this)), this.input.addEventListener("input", debounce(t => {
      this.onChange(t);
    }, 300).bind(this)));
  }
  toggleResetButton() {
    let t = this.resetButton.classList.contains("hidden");
    this.input.value.length > 0 && t ? this.resetButton.classList.remove("hidden") : 0 !== this.input.value.length || t || this.resetButton.classList.add("hidden");
  }
  onChange() {
    this.toggleResetButton();
  }
  shouldResetForm() {
    return !document.querySelector("[aria-selected=\"true\"] a");
  }
  ["onFormReset"]($) {
    $.preventDefault(), this.shouldResetForm() && (this.input.value = "", this.input.focus(), this.toggleResetButton());
  }
}
customElements.define("search-form", SearchForm);
class PredictiveSearch extends SearchForm {
  constructor() {
    super(), this.cachedResults = {}, this.predictiveSearchResults = this.querySelector("[data-predictive-search]"), this.allPredictiveSearchInstances = document.querySelectorAll("predictive-search"), this.isOpen = !1, this.abortController = new AbortController(), this.searchTerm = "", this.setupEventListeners();
  }
  ["setupEventListeners"]() {
    this.input.form.addEventListener("submit", this.onFormSubmit.bind(this)), this.input.addEventListener("focus", this.onFocus.bind(this)), this.addEventListener("focusout", this.onFocusOut.bind(this)), this.addEventListener("keyup", this.onKeyup.bind(this)), this.addEventListener("keydown", this.onKeydown.bind(this));
  }
  ["getQuery"]() {
    return this.input.value.trim();
  }
  ["onChange"]() {
    super.onChange();
    let t = this.getQuery();
    if (this.searchTerm && t.startsWith(this.searchTerm) || this.querySelector("#predictive-search-results-groups-wrapper")?.remove(), this.updateSearchForTerm(this.searchTerm, t), this.searchTerm = t, !this.searchTerm.length) {
      this.close(!0);
      return;
    }
    this.getSearchResults(this.searchTerm);
  }
  onFormSubmit($) {
    (!this.getQuery().length || this.querySelector("[aria-selected=\"true\"] a")) && $.preventDefault();
  }
  ["onFormReset"]($) {
    super.onFormReset($), super.shouldResetForm() && (this.searchTerm = "", this.abortController.abort(), this.abortController = new AbortController(), this.closeResults(!0));
  }
  ["onFocus"]() {
    let t = this.getQuery();
    t.length && (this.searchTerm !== t ? this.onChange() : "true" === this.getAttribute("results") ? this.open() : this.getSearchResults(this.searchTerm));
  }
  ["onFocusOut"]() {
    setTimeout(() => {
      this.contains(document.activeElement) || this.close();
    });
  }
  ["onKeyup"]($) {
    switch (this.getQuery().length || this.close(!0), $.preventDefault(), $.code) {
      case "ArrowUp":
        this.switchOption("up");
        break;
      case "ArrowDown":
        this.switchOption("down");
        break;
      case "Enter":
        this.selectOption();
    }
  }
  ["onKeydown"]($) {
    ("ArrowUp" === $.code || $.code === "ArrowDown") && $.preventDefault();
  }
  ["updateSearchForTerm"]($, t) {
    let e = this.querySelector("[data-predictive-search-search-for-text]"),
      i = e?.["innerText"];
    if (i) {
      if (i.match(RegExp($, "g")).length > 1) return;
      let s = i.replace($, t);
      e.innerText = s;
    }
  }
  switchOption($) {
    if (!this.getAttribute("open")) return;
    let x = "up" === $,
      e = this.querySelector('[aria-selected="true"]'),
      i = Array.from(this.querySelectorAll("li, button.predictive-search__item")).filter($ => null !== $.offsetParent),
      s = 0;
    if (x && !e) return;
    let a = -1,
      r = 0;
    for (; -1 === a && r <= i.length;) i[r] === e && (a = r), r++;
    if (this.statusElement.textContent = "", !x && e ? s = a === i.length - 1 ? 0 : a + 1 : x && (s = 0 === a ? i.length - 1 : a - 1), s === a) return;
    let n = i[s];
    n.setAttribute("aria-selected", !0), e && e.setAttribute("aria-selected", !1), this.input.setAttribute("aria-activedescendant", n.id);
  }
  ["selectOption"]() {
    let t = this.querySelector("[aria-selected=\"true\"] a, button[aria-selected=\"true\"]");
    t && t.click();
  }
  ["getSearchResults"]($) {
    let x = $.replace(" ", "-").toLowerCase();
    if (this.setLiveRegionLoadingState(), this.cachedResults[x]) {
      this.renderSearchResults(this.cachedResults[x]);
      return;
    }
    window.GiftsboxlySecurity.request(routes.predictive_search_url + "?q=" + encodeURIComponent($) + "&section_id=predictive-search", {
      signal: this.abortController.signal
    }).then($ => {
      if (!$.ok) {
        var e = Error($.status);
        throw this.close(), e;
      }
      return $.text();
    }).then($ => {
      let i = new DOMParser().parseFromString(window.GiftsboxlySecurity.sanitizeHTML($), "text/html").querySelector("#shopify-section-predictive-search").innerHTML;
      this.allPredictiveSearchInstances.forEach($ => {
        $.cachedResults[x] = i;
      }), this.renderSearchResults(i);
    })["catch"]($ => {
      if ($?.["code"] !== 20) throw this.close(), $;
    });
  }
  ["setLiveRegionLoadingState"]() {
    this.statusElement = this.statusElement || this.querySelector(".predictive-search-status"), this.loadingText = this.loadingText || this.getAttribute("data-loading-text"), this.setLiveRegionText(this.loadingText), this.setAttribute("loading", !0);
  }
  setLiveRegionText($) {
    this.statusElement.setAttribute("aria-hidden", "false"), this.statusElement.textContent = $, setTimeout(() => {
      this.statusElement.setAttribute("aria-hidden", "true");
    }, 1e3);
  }
  ["renderSearchResults"]($) {
    window.GiftsboxlySecurity.writeHTML(this.predictiveSearchResults, $, false), this.setAttribute("results", !0), this.setLiveRegionResults(), this.open();
  }
  ["setLiveRegionResults"]() {
    this.removeAttribute("loading"), this.setLiveRegionText(this.querySelector("[data-predictive-search-live-region-count-value]").textContent);
  }
  ["getResultsMaxHeight"]() {
    return this.resultsMaxHeight = window.innerHeight - document.querySelector(".section-header").getBoundingClientRect().bottom, this.resultsMaxHeight;
  }
  ["open"]() {
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || this.getResultsMaxHeight() + "px", this.setAttribute("open", !0), this.input.setAttribute("aria-expanded", !0), this.isOpen = !0;
  }
  ["close"]($ = !1) {
    this.closeResults($), this.isOpen = !1;
  }
  ["closeResults"]($ = !1) {
    $ && (this.input.value = "", this.removeAttribute("results"));
    let x = this.querySelector('[aria-selected="true"]');
    x && x.setAttribute("aria-selected", !1), this.input.setAttribute("aria-activedescendant", ""), this.removeAttribute("loading"), this.removeAttribute("open"), this.input.setAttribute("aria-expanded", !1), this.resultsMaxHeight = !1, this.predictiveSearchResults.removeAttribute("style");
  }
}
customElements.define("predictive-search", PredictiveSearch);
const defMed = "dat" + "a-def" + "er";
class CartDrawer extends HTMLElement {
  constructor() {
    super(), this.upsellHandles = this.getUpsellHandles(), this.quantityGifts = document.querySelector(".quantity-gifts"), this.checkForClear(), this.addEventListener("keyup", t => t.code === "Escape" && this.close()), this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this)), this.setHeaderCartIconAccessibility(), this.cartBodyScroll = 0;
    // Keep initial Liquid settings CSS outside the AJAX replacement. Response styles remain blocked.
    this.querySelectorAll("style").forEach(style => this.before(style));
    this.addEventListener("click", event => {
      if (event.target.closest(".drawer__close")) this.close();
    });
  }
  ["setHeaderCartIconAccessibility"]() {
    let t = document.querySelector("#cart-icon-bubble");
    if (!t || (t.tagName == "DIV" && (t = t.closest(".header__icon--cart")), !t)) return;
    let x = t.closest(".header__icons");
    t.setAttribute("role", "button"), t.setAttribute("aria-haspopup", "dialog"), t.addEventListener("click", x => {
      x.preventDefault(), this.open(t);
    }), this.oseid = x.querySelector("form").dataset[this.dataset.type], t.addEventListener("keydown", x => {
      x.code.toUpperCase() === "SPACE" && (x.preventDefault(), this.open(t));
    });
  }
  ["open"]($) {
    $ && this.setActiveElement($);
    let x = this.querySelector("[id^=\"Details-\"] summary");
    x && !x.hasAttribute("role") && this.setSummaryAccessibility(x), setTimeout(() => {
      this.classList.add("animate", "active");
    }), this.addEventListener("transitionend", () => {
      let x = this.classList.contains("is-empty") ? this.querySelector(".drawer__inner-empty") : document.getElementById("CartDrawer"),
        e = this.querySelector(".drawer__inner") || this.querySelector(".drawer__close");
      trapFocus(x, e);
    }, {
      once: !0
    }), document.body.classList.add("overflow-hidden");
    let e = this.querySelector("countdown-timer");
    e && e.playTimer();
  }
  ["close"]() {
    this.classList.remove("active"), removeTrapFocus(this.activeElement), document.body.classList.remove("overflow-hidden");
  }
  ["getUpsellHandles"]() {
    let t = this.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift"),
      x = [];
    return t.forEach(t => {
      t.dataset.handle && x.push(t.dataset.handle);
    }), x;
  }
  ["oneNonUpellRemaining"]() {
    let t = this.querySelectorAll(".cart-item"),
      x = 0;
    return t.forEach(t => {
      this.upsellHandles.forEach($ => {
        t.classList.contains("cart-item--product-" + $) && x++;
      });
    }), t.length - x <= 1;
  }
  ["checkForClear"]() {
    let t = this.oneNonUpellRemaining();
    this.querySelectorAll("cart-remove-button").forEach(x => {
      t ? x.clearCart = !0 : x.clearCart = !1;
    });
  }
  ["setSummaryAccessibility"]($) {
    $.setAttribute("role", "button"), $.setAttribute("aria-expanded", "false"), $.nextElementSibling.getAttribute("id") && $.setAttribute("aria-controls", $.nextElementSibling.id), $.addEventListener("click", $ => {
      $.currentTarget.setAttribute("aria-expanded", !$.currentTarget.closest("details").hasAttribute("open"));
    }), $.parentElement.addEventListener("keyup", onKeyUpEscape);
  }
  ["renderContents"]($, t = !1) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") && this.querySelector(".drawer__inner").classList.remove("is-empty"), this.productId = $.id, this.getSectionsToRender().forEach(t => {
      let i = t.selector ? document.querySelector(t.selector) : document.getElementById(t.id);
      if (i) {
        window.GiftsboxlySecurity.writeHTML(i, this.getSectionInnerHTML($.sections[t.id], t.selector), false);
        let s = i.querySelector(".cart-drawer__body");
        s && (s.scrollTop = this.cartBodyScroll);
      }
    }), this.checkForClear();
    let e = this.querySelector("countdown-timer");
    e && e.playTimer && e.playTimer();
    let i = [],
      s = [];
    if (this.querySelectorAll("cart-drawer-gift").forEach($ => {
      $.getUpdateRequired() && (this.querySelector(".cart-item--product-" + $.dataset.handle) ? $.dataset.selected === "false" && s.push($) : $.dataset.selected === "true" && i.push($));
    }), s.length > 0) s[0].removeFromCart();else if (i.length > 0) i[0].addToCart();else {
      this.quantityGifts && this.quantityGifts.initUnlock();
      let a = document.querySelectorAll("quantity-break-upsells");
      a.forEach($ => {
        $.initUnlock();
      });
    }
    validateCartGifts(), setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this)), t || this.open();
    });
  }
  ["getSectionInnerHTML"]($, t = ".shopify-section") {
    let e = new DOMParser().parseFromString(window.GiftsboxlySecurity.sanitizeHTML($), "text/html").querySelector(t);
    return "#CartDrawer" === t && fixParsedHtml(this, e), e.innerHTML;
  }
  ["getSectionsToRender"]() {
    return [{
      id: "cart-drawer",
      selector: "#CartDrawer"
    }, {
      id: "cart-icon-bubble"
    }];
  }
  ["getSectionDOM"]($, t = ".shopify-section") {
    return new DOMParser().parseFromString(window.GiftsboxlySecurity.sanitizeHTML($), "text/html").querySelector(t);
  }
  ["setActiveElement"]($) {
    this.activeElement = $;
  }
}
customElements.define("cart-drawer", CartDrawer);
class CartDrawerItems extends CartItems {
  constructor() {
    super(), this.cartDrawer = document.querySelector("cart-drawer"), this.secondCartItems = document.querySelector("cart-items");
  }
  updateCart() {
    window.GiftsboxlySecurity.request("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        updates: {},
        sections: ["cart-drawer", "cart-icon-bubble"],
        sections_url: window.location.pathname
      })
    }).then(t => t.json()).then(t => {
      document.querySelector("cart-drawer").renderContents(t, !0);
    }).catch(t => {
      console.error(t);
    });
  }
  getSectionInnerHTML($, t) {
    let e = new DOMParser().parseFromString(window.GiftsboxlySecurity.sanitizeHTML($), "text/html").querySelector(t);
    return t === ".drawer__inner" && fixParsedHtml(this.cartDrawer, e), e.innerHTML;
  }
  ["getSectionsToRender"]() {
    return [{
      id: "CartDrawer",
      section: "cart-drawer",
      selector: ".drawer__inner"
    }, {
      id: "cart-icon-bubble",
      section: "cart-icon-bubble",
      selector: ".shopify-section"
    }];
  }
}
function fixParsedHtml($, t) {
  let e = $.querySelector(".cart-drawer__body");
  if (e) {
    let i = document.querySelector("cart-drawer");
    i.cartBodyScroll = e.scrollTop;
  }
  let s = t.querySelector(".cart-timer");
  s && (oldTimer = $.querySelector(".cart-timer")) && window.GiftsboxlySecurity.writeHTML(s, oldTimer.innerHTML, false);
  let a = $.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift"),
    r = t.querySelectorAll('cart-drawer-upsell[data-toggle="true"], cart-drawer-gift');
  a.forEach(($, t) => {
    let i = r[t];
    if (i) {
      if ($.nodeName.toLowerCase() === "cart-drawer-upsell" && (i.dataset.selected = $.dataset.selected), i.dataset.id = $.dataset.id, i.querySelector("[name=\"id\"]").value = $.querySelector("[name=\"id\"]").value, i.querySelector(".upsell__image__img") && window.GiftsboxlySecurity.setResource(i.querySelector(".upsell__image__img"), "src", $.querySelector(".upsell__image__img").src), i.querySelector(".upsell__variant-picker")) {
        let s = $.querySelectorAll(".select__select");
        i.querySelectorAll(".select__select").forEach(($, t) => {
          $.value = s[t].value, $.querySelectorAll("option").forEach($ => {
            $.removeAttribute("selected"), $.value === s[t].value.trim() && $.setAttribute("selected", "");
          });
        });
      }
      if ("true" === $.dataset.updatePrices) {
        var a = i.querySelector(".upsell__price"),
          n = $.querySelector(".upsell__price");
        a && n && window.GiftsboxlySecurity.writeHTML(a, n.innerHTML, false);
      }
    }
  });
}
function serializePropValue($) {
  if (null == $) return "";
  if (typeof $ === "object") try {
    return JSON.stringify($);
  } catch {}
  return String($);
}
function getFocusableElements($) {
  return Array.from($.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
}
customElements.define("cart-drawer-items", CartDrawerItems), customElements.get("product-form") || customElements.define("product-form", class $ extends HTMLElement {
  constructor() {
    super(), this.form = this.querySelector("form"), this.form.addEventListener("submit", this.handleSubmit.bind(this)), this.formIdInput = this.form.querySelector("[name=id]"), this.formIdInput.disabled = !1, this.isMain = this.classList.contains("main-product-form"), this.additionalAtcButtons = this.isMain ? document.querySelectorAll(".main-product-atc") : [], this.skipCart = "true" === this.formIdInput.dataset.skipCart, this.cart = document.querySelector("cart-drawer") || document.querySelector("cart-notification"), this.isCartUpsell = this.dataset.isCartUpsell === "true", this.submitButton = this.querySelector("[type=\"submit\"]"), document.querySelector("cart-drawer") && (this.submitButton && this.submitButton.setAttribute("aria-haspopup", "dialog"), this.hasDrawer = !0), this.submitButton && (this.loadingSpinner = this.submitButton.querySelector(".loading-overlay__spinner")), this.displayedSubmitButton = document.getElementById("DisplayedSubmitBtn-" + this.dataset.section), this.bundleDeals = document.getElementById("bundle-deals-" + this.dataset.section), this.productInfo = document.getElementById("ProductInfo-" + this.dataset.section), this.quantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section), this.quantityBreaks && (this.quantityBreakUpsells = this.quantityBreaks.querySelectorAll("quantity-break-upsells")), this.quantityPicker = document.getElementById("Quantity-Form-" + this.dataset.section), this.customFields = document.querySelectorAll("[id^='CustomField-" + this.dataset.section + "-']"), this.quantityGifts = document.getElementById("quantity-gifts-" + this.dataset.section), this.mainBundleItems = document.querySelectorAll(".main-offer-item-" + this.dataset.section), this.variantInputs = this.form.querySelector(".product-form__variants");
  }
  ["handleSubmit"]($) {
    let x = null,
      e = !1;
    if ($ && ($.preventDefault(), $.currentTarget.classList.contains("button--has-spinner") && (x = $.currentTarget).classList.add("loading"), "true" === $.currentTarget.dataset.skipCartButton && (e = !0)), this.submitButton.getAttribute("aria-disabled") === "true") return;
    this.handleErrorMessage(), this.submitButton.setAttribute("aria-disabled", !0), !x && (this.submitButton.classList.add("loading"), this.loadingSpinner && this.loadingSpinner.classList.remove("hidden")), this.additionalAtcButtons.forEach($ => {
      $.setAttribute("disabled", "");
    }), this.displayedSubmitButton && (this.displayedSubmitButton.setAttribute("disabled", ""), this.displayedSubmitButton.classList.add("loading"));
    let i = !1,
      s = !1;
    if (this.variantInputs && !this.ref) {
      window.GiftsboxlySecurity.writeHTML(this.variantInputs, "", false);
      let a = "",
        r = [],
        n = new Set(),
        l = $ => {
          let x = null == $ ? "" : String($).trim();
          return "" === x ? null : x;
        },
        h = ($, x = 1, e = null) => {
          if (!$) return;
          let s = String($),
            a = Number(x) || 1,
            n = l(e),
            h = r.findIndex($ => {
              let t = l($.selling_plan);
              return $.id === s && t === n;
            });
          if (-1 === h) {
            let c = {
              id: s,
              quantity: a
            };
            n && (c.selling_plan = n), r.push(c);
          } else r[h].quantity += a;
        },
        c = $ => {
          $ && n.add(String($));
        };
      if (!this.hasDrawer || this.isCartUpsell || this.skipCart || this.cart.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift").forEach($ => {
        if ("true" === $.dataset.selected && !this.cart.querySelector(".cart-item--product-" + $.dataset.handle)) {
          let e = $.querySelector("input[name=\"selling_plan\"]")?.value || null;
          h($.dataset.id, 1, e);
        }
      }), this.bundleDeals) this.dataset.includePdpUpsells === "true" && document.querySelectorAll("product-info-upsell").forEach($ => {
        let e = $.querySelector("input[name=\"selling_plan\"]")?.value || null;
        $.dataset.selected === "true" && h($.dataset.id, 1, e);
      }), (this.bundleDeals.formVariants || []).forEach($ => {
        $ && h($.id, Number($.quantity) || 1);
      });else {
        this.quantityGifts && Array.isArray(this.quantityGifts.unlockedItems) && this.quantityGifts.unlockedItems.length > 0 && this.quantityGifts.unlockedItems.forEach($ => h($, 1)), this.upsells = document.querySelectorAll(".product-info-upsell-" + this.dataset.section);
        for (let d = this.upsells.length - 1; d >= 0; d--) {
          let o = this.upsells[d];
          if (o && "true" === o.dataset.selected) {
            let f = o.querySelector("input[name=\"selling_plan\"]")?.["value"] || null;
            h(o.dataset.id, 1, f);
          }
        }
        if (this.quantityBreakUpsells && this.quantityBreakUpsells.forEach($ => {
          ($.unlockedItems || []).forEach($ => {
            let e = String($);
            r.some($ => String($.id) === e) || h(e, 1);
          });
        }), 0 === this.mainBundleItems.length) {
          if (this.quantityBreaks && Array.isArray(this.quantityBreaks.formVariants) && this.quantityBreaks.formVariants.length > 0) this.quantityBreaks.formVariants.forEach($ => {
            h($, 1), c($);
          }), s = !0;else {
            let u = 1;
            this.quantityBreaks ? u = Number(this.quantityBreaks.selectedQuantity) || 1 : this.quantityPicker ? u = Number(this.quantityPicker.querySelector(".quantity__input")?.["value"]) || 1 : this.querySelector("input[name=\"quantity\"]") && (u = Number(this.querySelector('input[name="quantity"]').value) || 1);
            let b = this.formIdInput.value;
            h(b, u), c(b);
          }
        }
        for (let p = this.mainBundleItems.length - 1; p >= 0; p--) {
          let _ = this.mainBundleItems[p];
          h(_.dataset.id, 1), (void 0 === _.dataset.isMainPdpProduct || "true" === _.dataset.isMainPdpProduct) && c(_.dataset.id);
        }
      }
      if (r.length > 1 || s || this.bundleDeals || this.mainBundleItems.length > 0) {
        let m = [];
        this.customFields?.["forEach"]($ => {
          $?.["dataset"]?.["disabled"] !== "true" && m.push({
            fieldName: $.fieldName,
            value: $.prevValue
          });
        });
        let y = null;
        this.classList.contains("main-product-form") && (y = this.querySelector('.appstle-active-option [name="selling_plan"]') || this.querySelector("[name=\"selling_plan\"]") || document.querySelector('.sls-purchase [name="selling_plan"], skio-plan-picker [name="selling_plan"]'));
        let g = this.querySelector("#simple-bundles-io-options"),
          v = "input[name^=\"properties[\"]:not(#validator):not(.shrine-property-input):not([type=\"radio\"])," + 'input[name^="properties["][type="radio"]:checked:not(#validator):not(.shrine-property-input),' + "select[name^=\"properties[\"]:not(#validator):not(.shrine-property-input)",
          S = this.classList.contains("main-product-form") ? this.productInfo ? this.productInfo.querySelectorAll(v) : document.querySelectorAll(v) : [];
        r.forEach($ => {
          if (n.has($.id)) {
            let e = [];
            m.forEach($ => {
              e.push({
                fieldName: $.fieldName,
                value: $.value
              });
            }), g && g.querySelectorAll("select[name^=\"properties[\"], input[name^=\"properties[\"]").forEach($ => {
              let i = $.name.match(/properties\[(.*?)\]/);
              i && e.push({
                fieldName: i[1],
                value: $.value
              });
            }), this.classList.contains("main-product-form") && S.forEach($ => {
              let i = $.name.match(/properties\[(.*?)\]/);
              i && ($.type === "file" ? $.files && $.files.length > 0 && e.push({
                fieldName: i[1],
                value: $.files[0],
                isFile: !0
              }) : e.push({
                fieldName: i[1],
                value: $.value
              }));
            }), e.length && ($.properties = e), y && typeof y.value === "string" && y.value.length > 0 && ($.selling_plan = y.value);
          }
        });
        let k = document.createDocumentFragment(),
          T = [];
        r.forEach(($, x) => {
          a += '<input type="hidden" name="items[' + x + '][quantity]" value="' + $.quantity + '">' + ("<input type=\"hidden\" name=\"items[" + x + '][id]" value="') + $.id + '">', $.selling_plan && (a += '<input type="hidden" name="items[' + x + '][selling_plan]" value="' + $.selling_plan + '">'), Array.isArray($.properties) && $.properties.length && $.properties.forEach($ => {
            if ($.isFile) T.push({
              name: "items[" + x + "][properties][" + $.fieldName + "]",
              file: $.value
            });else {
              let i = document.createElement("input");
              i.type = "hidden", i.name = "items[" + x + "][properties][" + $.fieldName + "]", i.value = serializePropValue($.value), k.appendChild(i);
            }
          });
        }), this._filePropsForFormData = T, window.GiftsboxlySecurity.writeHTML(this.variantInputs, a, false), this.variantInputs.appendChild(k), i = !0;
      }
    }
    var E = fetchConfig("javascript");
    E.headers["X-Requested-With"] = "XMLHttpRequest", delete E.headers["Content-Type"];
    var B = new FormData(this.form);
    if (this._filePropsForFormData && this._filePropsForFormData.length > 0 && (this._filePropsForFormData.forEach(({
      name: $,
      file: x
    }) => {
      B.append($, x);
    }), this._filePropsForFormData = []), this.ref && (i = !0), this.cart && (B.append("sections", this.cart.getSectionsToRender().map($ => $.id)), B.append("sections_url", window.location.pathname), this.cart.setActiveElement(document.activeElement)), i) {
      let C = this.dataset.options ? this.dataset.options.split(",") : [],
        q = ["id", "quantity", ...C];
      for (let I = 0; I < q.length; I++) B["delete"](q[I]);
    }
    E.body = B, window.GiftsboxlySecurity.request("" + routes.cart_add_url, E).then($ => $.json()).then(async $ => {
      if ($.status) {
        this.handleErrorMessage($.description);
        let i = this.submitButton.querySelector(".sold-out-message");
        if (!i) return;
        this.submitButton.setAttribute("aria-disabled", !0), this.submitButton.querySelector("span").classList.add("hidden"), i.classList.remove("hidden"), this.error = !0;
        return;
      }
      if (!$.sections && this.cart) try {
        let s = await window.GiftsboxlySecurity.request(routes.cart_url + "?sections=" + this.cart.getSectionsToRender().map($ => $.id).join(",")),
          a = await s.json();
        $.sections = a;
      } catch (r) {
        console.error("Add to cart fallback failed", r), this.handleErrorMessage(window.cartStrings.error || "Something went wrong.");
        return;
      }
      if (this.skipCart || e) {
        window.location = "/checkout";
        return;
      }
      if (!this.cart) {
        window.location = window.routes.cart_url;
        return;
      }
      this.error || publish(PUB_SUB_EVENTS.cartUpdate, {
        source: "product-form",
        productVariantId: this.formIdInput.id,
        cartData: $
      }), this.error = !1;
      let n = this.closest("quick-add-modal");
      n ? (document.body.addEventListener("modalClosed", () => {
        setTimeout(() => {
          this.cart.renderContents($, this.isCartUpsell);
        });
      }, {
        once: !0
      }), n.hide(!0)) : this.cart.renderContents($, this.isCartUpsell);
    })["catch"]($ => {
      console.error($);
    })["finally"](() => {
      x ? x.classList.remove("loading") : (this.submitButton.classList.remove("loading"), this.loadingSpinner && this.loadingSpinner.classList.add("hidden")), this.additionalAtcButtons.forEach(t => {
        t.removeAttribute("disabled");
      }), this.displayedSubmitButton && (this.displayedSubmitButton.removeAttribute("disabled"), this.displayedSubmitButton.classList.remove("loading")), this.cart && this.cart.classList.contains("is-empty") && this.cart.classList.remove("is-empty"), this.error || this.submitButton.removeAttribute("aria-disabled");
    });
  }
  handleErrorMessage($ = !1) {
    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper"), this.errorMessageWrapper && (this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message"), this.errorMessageWrapper.toggleAttribute("hidden", !$), $ && (this.errorMessage.textContent = $));
  }
}), customElements.get("product-info") || customElements.define("product-info", class $ extends HTMLElement {
  constructor() {
    super(), this.deferredMedia = document.querySelector("[" + defMed + "]"), this.input = this.querySelector(".quantity__input"), this.currentVariant = this.querySelector(".product-variant-id"), this.variantSelects = this.querySelector("variant-radios"), this.submitButton = this.querySelector("[type=\"submit\"]"), this.form = this.querySelector("#ProductForm-" + this.dataset.section), this.hasUrl = null !== this.dataset.url;
  }
  ["cartUpdateUnsubscriber"] = void 0;
  ["variantChangeUnsubscriber"] = void 0;
  ["connectedCallback"]() {
    this.form && this.input && (this.quantityForm = this.querySelector(".product-form__quantity"), this.quantityForm && (this.setQuantityBoundries(), this.dataset.originalSection || (this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this))), this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, t => {
      let e = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
      t.data.sectionId === e && (this.updateQuantityRules(t.data.sectionId, t.data.html), this.setQuantityBoundries());
    })));
  }
  ["disconnectedCallback"]() {
    this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber(), this.variantChangeUnsubscriber && this.variantChangeUnsubscriber();
  }
  ["setQuantityBoundries"]() {
    let t = {
        cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
        min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
        max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
        step: this.input.step ? parseInt(this.input.step) : 1
      },
      x = t.min,
      e = null === t.max ? t.max : t.max - t.cartQuantity;
    null !== e && (x = Math.min(x, e)), t.cartQuantity >= t.min && (x = Math.min(x, t.step));
    let i = parseInt(this.input.value) || x,
      s = i;
    s < x && (s = x), null !== e && s > e && (s = e), this.input.min = x, this.input.max = e, this.input.value = s, publish(PUB_SUB_EVENTS.quantityUpdate, void 0);
  }
  ["initShareLinks"]() {
    let t = this.querySelector(".share-url-button");
    t || (this.shareUrl = !0);
  }
  fetchQuantityRules() {
    this.currentVariant && this.currentVariant.value && (this.querySelector(".quantity__rules-cart .loading-overlay").classList.remove("hidden"), window.GiftsboxlySecurity.request(this.dataset.url + "?variant=" + this.currentVariant.value + "&section_id=" + this.dataset.section).then(t => t.text()).then(t => {
      let e = new DOMParser().parseFromString(window.GiftsboxlySecurity.sanitizeHTML(t), "text/html");
      this.updateQuantityRules(this.dataset.section, e), this.setQuantityBoundries();
    })["catch"](t => {
      console.error(t);
    }).finally(() => {
      this.querySelector(".quantity__rules-cart .loading-overlay").classList.add("hidden");
    }));
  }
  updateQuantityRules($, t) {
    let e = t.getElementById("Quantity-Form-" + $);
    if (e && this.quantityForm) {
      let i = [".quantity__input", ".quantity__rules", ".quantity__label"];
      for (let s of i) {
        let a = this.quantityForm.querySelector(s),
          r = e.querySelector(s);
        if (a && r) {
          if (s === ".quantity__input") {
            let n = ["data-cart-quantity", "data-min", "data-max", "step"];
            for (let l of n) {
              let h = r.getAttribute(l);
              null !== h && a.setAttribute(l, h);
            }
          } else window.GiftsboxlySecurity.writeHTML(a, r.innerHTML, false);
        }
      }
    }
  }
}), document.querySelectorAll("[id^=\"Details-\"] summary").forEach($ => {
  $.setAttribute("role", "button"), $.setAttribute("aria-expanded", $.parentNode.hasAttribute("open")), $.nextElementSibling?.["getAttribute"]("id") && $.setAttribute("aria-controls", $.nextElementSibling.id), $.addEventListener("click", $ => {
    $.currentTarget.setAttribute("aria-expanded", !$.currentTarget.closest("details").hasAttribute("open"));
  }), $.closest("header-drawer") || $.parentElement.addEventListener("keyup", onKeyUpEscape);
});
const trapFocusHandlers = {};
function trapFocus($, t = $) {
  var e = getFocusableElements($),
    i = e[0],
    s = e[e.length - 1];
  removeTrapFocus(), trapFocusHandlers.focusin = t => {
    (t.target === $ || t.target === s || t.target === i) && document.addEventListener("keydown", trapFocusHandlers.keydown);
  }, trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  }, trapFocusHandlers.keydown = function (t) {
    t.code.toUpperCase() === "TAB" && (t.target !== s || t.shiftKey || (t.preventDefault(), i.focus()), (t.target === $ || t.target === i) && t.shiftKey && (t.preventDefault(), s.focus()));
  }, document.addEventListener("focusout", trapFocusHandlers.focusout), document.addEventListener("focusin", trapFocusHandlers.focusin), t.focus(), t.tagName === "INPUT" && ["search", "text", "email", "url"].includes(t.type) && t.value && t.setSelectionRange(0, t.value.length);
}
function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach(frame => {
    frame.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach(frame => {
    frame.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('media-gallery template video').forEach(video => video.pause());
  document.querySelectorAll('product-model').forEach(model => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}
function removeTrapFocus($ = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin), document.removeEventListener("focusout", trapFocusHandlers.focusout), document.removeEventListener("keydown", trapFocusHandlers.keydown), $ && $.focus();
}
function onKeyUpEscape($) {
  if ($.code.toUpperCase() !== "ESCAPE") return;
  let x = $.target.closest("details[open]");
  if (!x) return;
  let e = x.querySelector("summary");
  x.removeAttribute("open"), e.setAttribute("aria-expanded", !1), e.focus();
}
class QuantityInput extends HTMLElement {
  constructor() {
    super(), this.input = this.querySelector("input"), this.changeEvent = new Event("change", {
      bubbles: !0
    }), this.quantityGifts = document.getElementById("quantity-gifts-" + this.dataset.section), this.input.addEventListener("change", this.onInputChange.bind(this)), this.querySelectorAll("button").forEach(t => t.addEventListener("click", this.onButtonClick.bind(this)));
  }
  quantityUpdateUnsubscriber = void 0;
  connectedCallback() {
    this.validateQtyRules(), this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }
  ["disconnectedCallback"]() {
    this.quantityUpdateUnsubscriber && this.quantityUpdateUnsubscriber();
  }
  ["onInputChange"]($) {
    this.validateQtyRules();
  }
  ["onButtonClick"]($) {
    $.preventDefault();
    let x = this.input.value;
    $.target.name === "plus" ? this.input.stepUp() : this.input.stepDown(), x !== this.input.value && this.input.dispatchEvent(this.changeEvent);
  }
  ["validateQtyRules"]() {
    let t = parseInt(this.input.value);
    if (this.input.min) {
      let x = parseInt(this.input.min),
        e = this.querySelector(".quantity__button[name='minus']");
      e.classList.toggle("disabled", t <= x);
    }
    if (this.input.max) {
      let i = parseInt(this.input.max),
        s = this.querySelector(".quantity__button[name='plus']");
      s.classList.toggle("disabled", t >= i);
    }
    this.quantityGifts && this.quantityGifts.unlockGifts && this.quantityGifts.unlockGifts(t);
  }
}
function debounce($, t) {
  let x;
  return (...e) => {
    clearTimeout(x), x = setTimeout(() => $.apply(this, e), t);
  };
}
function fetchConfig($ = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/" + $
    }
  };
}
function addDays($, t) {
  var x = new Date($);
  return x.setDate(x.getDate() + t), x;
}
customElements.define("quantity-input", QuantityInput), typeof window.Shopify == "undefined" && (window.Shopify = {}), Shopify.bind = function ($, t) {
  return function () {
    return $.apply(t, arguments);
  };
}, Shopify.setSelectorByValue = function ($, t) {
  for (var e = 0, i = $.options.length; e < i; e++) {
    var s = $.options[e];
    if (t == s.value || t == s.innerHTML) return $.selectedIndex = e, e;
  }
}, Shopify.addListener = function ($, t, x) {
  $.addEventListener ? $.addEventListener(t, x, !1) : $.attachEvent("on" + t, x);
}, Shopify.postLink = function ($, t) {
  var e = (t = t || {}).method || "post",
    i = t.parameters || {},
    s = document.createElement("form");
  for (var a in s.setAttribute("method", e), s.setAttribute("action", window.GiftsboxlySecurity.formURL($)), i) {
    var r = document.createElement("input");
    r.setAttribute("type", "hidden"), r.setAttribute("name", a), r.setAttribute("value", i[a]), s.appendChild(r);
  }
  document.body.appendChild(s), s.submit(), document.body.removeChild(s);
}, Shopify.CountryProvinceSelector = function ($, t, x) {
  this.countryEl = document.getElementById($), this.provinceEl = document.getElementById(t), this.provinceContainer = document.getElementById(x.hideElement || t), Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this)), this.initCountry(), this.initProvince();
}, Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var t = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, t), this.countryHandler();
  },
  initProvince: function () {
    var t = this.provinceEl.getAttribute("data-default");
    t && this.provinceEl.options.length > 0 && Shopify.setSelectorByValue(this.provinceEl, t);
  },
  countryHandler: function ($) {
    var x = this.countryEl.options[this.countryEl.selectedIndex],
      e = x.getAttribute("data-provinces"),
      i = JSON.parse(e);
    if (this.clearOptions(this.provinceEl), i && 0 == i.length) this.provinceContainer.style.display = "none";else {
      for (var s = 0; s < i.length; s++) {
        var x = document.createElement("option");
        x.value = i[s][0], window.GiftsboxlySecurity.writeHTML(x, i[s][1], false), this.provinceEl.appendChild(x);
      }
      this.provinceContainer.style.display = "";
    }
  },
  clearOptions: function ($) {
    for (; $.firstChild;) $.removeChild($.firstChild);
  },
  setOptions: function ($, t) {
    for (var e = 0; e < t.length; e++) {
      var i = document.createElement("option");
      i.value = t[e], window.GiftsboxlySecurity.writeHTML(i, t[e], false), $.appendChild(i);
    }
    t.length;
  }
};
class InternalVideo extends HTMLElement {
  constructor() {
    if (super(), this.playButton = this.querySelector(".internal-video__play"), this.noPlayBtn = this.dataset.noPlayBtn === "true", this.loaded = !1, this.suspended = !1, this.soundButton = this.querySelector(".internal-video__sound-btn"), this.video = this.querySelector("video"), this.invalidFormatSrc = this.video.querySelector("source[type=\"application/x-mpegURL\"]"), this.invalidFormatSrc && this.invalidFormatSrc.remove(), this.timeline = this.querySelector(".internal-video__timeline"), this.dragging = !1, this.fullscreenButton = this.querySelector(".internal-video__fullscreen-btn"), this.playButton && this.playButton.addEventListener("click", this.playVideo.bind(this)), this.soundButton && this.soundButton.addEventListener("click", this.toggleSound.bind(this)), this.video && this.video.addEventListener("ended", this.endedVideo.bind(this)), this.timeline && (this.video.addEventListener("timeupdate", this.updateTimeline.bind(this)), this.timeline.addEventListener("click", this.seekVideo.bind(this)), this.timeline.addEventListener("mousedown", this.startDrag.bind(this)), this.timeline.addEventListener("touchstart", this.startDrag.bind(this)), document.addEventListener("mouseup", this.stopDrag.bind(this)), document.addEventListener("touchend", this.stopDrag.bind(this)), document.addEventListener("mousemove", this.drag.bind(this)), document.addEventListener("touchmove", this.drag.bind(this))), this.video.addEventListener("waiting", this.showSpinner.bind(this)), this.video.addEventListener("canplaythrough", this.hideSpinner.bind(this)), this.video.addEventListener("play", this.hideSpinner.bind(this)), this.dataset.autoplay === "true" && "IntersectionObserver" in window) {
      let t = {
        root: null,
        rootMargin: "0px",
        threshold: .05
      };
      this.observer = new IntersectionObserver(this.handleIntersection.bind(this), t), this.observer.observe(this);
    }
    this.fullscreenButton && (this.fullscreenButton.addEventListener("click", this.toggleFullscreen.bind(this)), document.addEventListener("fullscreenchange", this.handleFullscreenChange.bind(this)));
  }
  ["playVideo"]() {
    if (this.video.paused) {
      this.loaded || (this.video.load(), this.loaded = !0), this.classList.add("internal-video--playing"), this.playButton && this.noPlayBtn && (this.playButton.style.visibility = "hidden");
      let t = this.video.play();
      void 0 !== t && t.then(() => {
        this.classList.add("internal-video--playing"), this.playButton && this.noPlayBtn && (this.playButton.style.visibility = "hidden");
      })["catch"](t => {
        this.classList.remove("internal-video--playing"), this.playButton && this.noPlayBtn && (this.playButton.style.visibility = "visible");
      });
    } else this.video.pause(), this.classList.remove("internal-video--playing");
  }
  ["endedVideo"]() {
    this.classList.remove("internal-video--playing");
  }
  toggleSound() {
    this.video.muted ? (this.video.muted = !1, this.classList.remove("internal-video--muted")) : (this.video.muted = !0, this.classList.add("internal-video--muted"));
  }
  updateTimeline() {
    let t = this.video.currentTime / this.video.duration * 100;
    this.style.setProperty("--completed", t + "%");
  }
  ["hideSpinner"]() {
    this.classList.remove("internal-video--loading");
  }
  startDrag($) {
    $.preventDefault(), this.dragging = !0, this.drag($);
  }
  ["stopDrag"]() {
    this.dragging = !1;
  }
  ["drag"]($) {
    this.dragging && ($.touches && ($ = $.touches[0]), this.seekVideo($));
  }
  ["seekVideo"]($) {
    let x = this.timeline.getBoundingClientRect(),
      e = $.clientX - x.left,
      i = e / x.width;
    this.video.currentTime = i * this.video.duration;
  }
  ["showSpinner"]() {
    this.classList.add("internal-video--loading");
  }
  ["hideSpinner"]() {
    this.classList.remove("internal-video--loading");
  }
  ["handleIntersection"]($) {
    $.forEach($ => {
      if ($.isIntersecting) {
        for (let e of this.video.querySelectorAll("source[data-src]")) window.GiftsboxlySecurity.setResource(e, "src", e.getAttribute("data-src")), e.removeAttribute("data-src");
        this.video.load();
        var i = this.video.play();
        void 0 !== i && i.catch($ => {
          $.name === "NotAllowedError" && (this.classList.remove("internal-video--playing"), this.playButton && this.noPlayBtn && (this.playButton.style.visibility = "visible"));
        }).then(() => {
          this.video.play();
        }), this.observer.disconnect();
      }
    });
  }
  ["toggleFullscreen"]() {
    document.fullscreenElement ? document.exitFullscreen() : this.requestFullscreen();
  }
  ["handleFullscreenChange"]() {
    document.fullscreenElement === this ? this.classList.add("internal-video--fullscreen") : this.classList.remove("internal-video--fullscreen");
  }
}
customElements.define("internal-video", InternalVideo);
class ComparisonSlider extends HTMLElement {
  constructor() {
    super(), this.sliderOverlay = this.querySelector(".comparison-slider__overlay"), this.sliderLine = this.querySelector(".comparison-slider__line"), this.sliderInput = this.querySelector(".comparison-slider__input"), this.sliderInput.addEventListener("input", this.handleChange.bind(this));
  }
  ["handleChange"]($) {
    let x = $.currentTarget.value;
    this.sliderOverlay.style.width = x + "%", this.sliderLine.style.left = x + "%", this.style.setProperty("--position", x + "%");
  }
}
customElements.define("comparison-slider", ComparisonSlider);
class PromoPopup extends HTMLElement {
  constructor() {
    if (super(), this.testMode = "true" === this.dataset.testMode, this.secondsDelay = this.dataset.delaySeconds, this.daysFrequency = this.dataset.delayDays, this.modal = this.querySelector(".sign-up-popup-modal"), this.timer = this.querySelector(".popup-modal__timer"), this.timerDuration = this.dataset.timerDuration, this.closeBtns = this.querySelectorAll(".promp-popup__close-btn"), this.overlay = document.querySelector(".sign-up-popup-overlay"), this.storageKey = "promo-bar-data-" + window.location.host, this.testMode) this.timer && this.displayPromoTimer();else if (null === localStorage.getItem(this.storageKey)) this.openPopupModal();else {
      let t = JSON.parse(localStorage.getItem(this.storageKey)),
        x = new Date(t.next_display_date);
      currentDate.getTime() > x.getTime() && this.openPopupModal();
    }
    this.closeBtns.forEach(t => {
      t.addEventListener("click", this.closeModal.bind(this));
    });
  }
  ["openPopupModal"]() {
    setTimeout(() => {
      this.modal.classList.add("popup-modal--active"), this.overlay.classList.add("popup-overlay--active");
      let t = addDays(currentDate, parseInt(this.daysFrequency));
      localStorage.setItem(this.storageKey, JSON.stringify({
        next_display_date: t,
        dismissed: !1
      })), this.timer && this.displayPromoTimer();
    }, 1e3 * parseInt(this.secondsDelay) + 3e3);
  }
  ["displayPromoTimer"]() {
    this.minutesSpan = this.querySelector(".popup-modal__timer__minutes"), this.secondsSpan = this.querySelector(".popup-modal__timer__seconds"), this.totalSeconds = 60 * parseFloat(this.timerDuration), this.updateTimer(), setInterval(() => {
      this.totalSeconds -= 1, this.updateTimer(), this.totalSeconds <= 0 && (this.totalSeconds = 60 * parseFloat(this.timerDuration) - 45);
    }, 1e3);
  }
  updateTimer() {
    let t = Math.floor(this.totalSeconds / 60);
    1 === t.toString().length && (t = "0" + t);
    let x = this.totalSeconds % 60;
    1 === x.toString().length && (x = "0" + x), this.minutesSpan.innerText = t, this.secondsSpan.innerText = x;
  }
  ["closeModal"]() {
    this.modal.classList.remove("popup-modal--active"), this.overlay.classList.remove("popup-overlay--active");
  }
}
customElements.define("promo-popup", PromoPopup);
class SectionsGroup extends HTMLElement {
  constructor() {
    super(), this.sectionOneContainer = this.querySelector(".section-group__section-one-container"), this.sectionTwoContainer = this.querySelector(".section-group__section-two-container"), this.transferSections(), document.addEventListener("shopify:section:load", this.transferSections.bind(this));
  }
  ["transferSections"]() {
    this.sectionOne = document.querySelector(this.dataset.sectionOneId + " .content-for-grouping"), this.sectionTwo = document.querySelector(this.dataset.sectionTwoId + " .content-for-grouping"), this.sectionOne && !this.sectionOneContainer.childNodes.length && this.sectionOneContainer.appendChild(this.sectionOne), this.sectionTwo && !this.sectionTwoContainer.childNodes.length && this.sectionTwoContainer.appendChild(this.sectionTwo);
  }
}
customElements.define("section-group", SectionsGroup);
class ClickableDiscount extends HTMLElement {
  constructor() {
    super(), this.button = this.querySelector(".clickable-discount__btn"), this.button.addEventListener("click", this.handleClick.bind(this)), this.dataset.applied === "true" ? this.handleClick() : this.reapplyDiscountIfApplicable();
  }
  handleClick() {
    this.dataset.loading = "true", this.button.disabled = !0, this.dataset.error = "false", window.GiftsboxlySecurity.request("/discount/" + this.dataset.code).then(t => {
      if (!t.ok) throw Error("Error");
      this.dataset.applied = "true", sessionStorage.setItem("discount-" + this.dataset.code + "-applied", "true");
    })["catch"](t => {
      this.dataset.error = "true", this.button.disabled = !1;
    })["finally"](() => {
      this.dataset.loading = "false";
    });
  }
  ["reapplyDiscountIfApplicable"]() {
    let t = this.dataset.code;
    sessionStorage.getItem("discount-" + t + "-applied") && (this.dataset.applied = "true", this.button.disabled = !0, setTimeout(() => {
      window.GiftsboxlySecurity.request("/discount/" + t)["catch"]($ => {
        this.dataset.applied = "false", this.button.disabled = !1;
      });
    }, 3e3));
  }
}
customElements.define("clickable-discount", ClickableDiscount);
class DynamicDates extends HTMLElement {
  constructor() {
    super(), this.dateFormat = this.dataset.dateFormat, this.days = this.rearrangeDays(this.dataset.dayLabels.split(",")), this.months = this.dataset.monthLabels.split(","), this.elementsToChange = this.querySelectorAll("[data-dynamic-date=\"true\"]"), this.daysToSkip = this.parseDaysToSkip(this.dataset.daysToSkip || ""), this.datesToSkip = this.parseDatesToSkip(this.dataset.datesToSkip || ""), this.insertDates(), document.addEventListener("shopify:section:load", t => {
      this.insertDates();
    });
  }
  ["addDaysSkipping"]($, t) {
    let x = new Date($),
      e = Number(t) || 0;
    for (; e > 0;) x = addDays(x, 1), !this.isSkipped(x) && e--;
    return x;
  }
  ["parseDaysToSkip"]($) {
    let x = new Map([["sunday", 0], ["monday", 1], ["tuesday", 2], ["wednesday", 3], ["thursday", 4], ["friday", 5], ["saturday", 6]]),
      e = new Set();
    return $ && $.split(",").forEach($ => {
      let s = $.trim();
      x.has(s) && e.add(x.get(s));
    }), e;
  }
  ["parseDatesToSkip"]($) {
    let x = new Set();
    return $ && $.split(",").forEach($ => {
      let i = $.trim();
      if (!i) return;
      let s = i.split("-");
      if (2 === s.length) {
        let a = String(Math.max(1, Math.min(12, Number(s[0])))).padStart(2, "0"),
          r = String(Math.max(1, Math.min(31, Number(s[1])))).padStart(2, "0");
        x.add(a + "-" + r);
      } else if (3 === s.length) {
        let n = String(Math.max(1, Math.min(12, Number(s[1])))).padStart(2, "0"),
          l = String(Math.max(1, Math.min(31, Number(s[2])))).padStart(2, "0");
        x.add(n + "-" + l);
      }
    }), x;
  }
  ["isSkipped"]($) {
    let x = this.daysToSkip.has($.getDay()),
      e = String($.getMonth() + 1).padStart(2, "0"),
      i = String($.getDate()).padStart(2, "0"),
      s = this.datesToSkip.has(e + "-" + i);
    return x || s;
  }
  nextValidDate($) {
    let x = new Date($);
    for (; this.isSkipped(x);) x = addDays(x, 1);
    return x;
  }
  ["insertDates"]() {
    this.elementsToChange.forEach($ => {
      let x = $.dataset.text,
        e = parseInt($.dataset.minDays),
        i = parseInt($.dataset.maxDays),
        s = this.addDaysSkipping(currentDate, e),
        a = this.addDaysSkipping(currentDate, i),
        r = "th",
        n = s.getDate();
      [1, 21, 31].includes(n) ? r = "st" : [2, 22].includes(n) ? r = "nd" : [3, 23].includes(n) && (r = "rd");
      let l = "th",
        h = a.getDate();
      [1, 21, 31].includes(h) ? l = "st" : [2, 22].includes(h) ? l = "nd" : [3, 23].includes(h) && (l = "rd");
      let c, d;
      if (this.dateFormat === "day_dd_mm") c = this.days[s.getDay()] + ", " + s.getDate() + ". " + this.months[s.getMonth()], d = this.days[a.getDay()] + ", " + a.getDate() + ". " + this.months[a.getMonth()];else if (this.dateFormat === "mm_dd") c = this.months[s.getMonth()] + " " + s.getDate() + r, d = this.months[a.getMonth()] + " " + a.getDate() + l;else if (this.dateFormat === "dd_mm") c = s.getDate() + ". " + this.months[s.getMonth()], d = a.getDate() + ". " + this.months[a.getMonth()];else if (this.dateFormat === "dd_mm_no_dot") c = s.getDate() + " " + this.months[s.getMonth()], d = a.getDate() + " " + this.months[a.getMonth()];else if ("day_dd_mm_numeric" === this.dateFormat) {
        let o = String(s.getDate()).padStart(2, "0"),
          f = String(s.getMonth() + 1).padStart(2, "0");
        c = this.days[s.getDay()] + ", " + o + ". " + f + ".";
        let u = String(a.getDate()).padStart(2, "0"),
          b = String(a.getMonth() + 1).padStart(2, "0");
        d = this.days[a.getDay()] + ", " + u + ". " + b + ".";
      } else if ("dd_mm_numeric" === this.dateFormat) {
        let p = String(s.getDate()).padStart(2, "0"),
          _ = String(s.getMonth() + 1).padStart(2, "0");
        c = p + ". " + _ + ".";
        let m = String(a.getDate()).padStart(2, "0"),
          y = String(a.getMonth() + 1).padStart(2, "0");
        d = m + ". " + y + ".";
      } else c = this.days[s.getDay()] + ", " + this.months[s.getMonth()] + " " + s.getDate() + r, d = this.days[a.getDay()] + ", " + this.months[a.getMonth()] + " " + a.getDate() + l;
      let g = x.replace("[start_date]", c),
        v = g.replace("[end_date]", d);
      window.GiftsboxlySecurity.writeHTML($, v, false);
    });
  }
  rearrangeDays($) {
    return $.unshift($[6]), $.length = 7, $;
  }
}
customElements.define("dynamic-dates", DynamicDates);
class StickyAtc extends HTMLElement {
  constructor() {
    super(), this.displayMode = this.dataset.displayMode || (this.dataset.afterScroll === "true" ? "after_scroll" : "always"), this.displayThreshold = parseFloat(this.dataset.displayThreshold || 0), this.isScrollBtn = this.dataset.scrollBtn === "true", this.mainAtcBtn = document.querySelector("#ProductSubmitButton-" + this.dataset.section), this.floatingBtns = document.querySelectorAll(".floating-btn"), this.footerSpacing(), this.displayMode === "always" ? this.floatingBtns.forEach(t => {
      t.style.setProperty("--sticky-atc-offset", this.offsetHeight + "px");
    }) : (this.checkScroll(), document.addEventListener("scroll", this.checkScroll.bind(this))), this.isScrollBtn && (this.scrollBtn = this.querySelector(".sticky-atc__scroll-btn"), this.scrollDestination = document.querySelector("" + this.dataset.scrollDestination.replace("id", this.dataset.section)), this.scrollBtn && this.scrollDestination && this.scrollBtn.addEventListener("click", this.handleScrollBtn.bind(this)));
  }
  ["checkScroll"]() {
    let t = !1;
    if (this.displayMode === "after_scroll") {
      if (!this.mainAtcBtn) return;
      let x = this.mainAtcBtn.getBoundingClientRect().top + window.scrollY,
        e = x + this.mainAtcBtn.offsetHeight;
      t = window.scrollY > e;
    } else if (this.displayMode === "after_pixels") t = window.scrollY > this.displayThreshold;else if ("after_percent" === this.displayMode) {
      let i = document.documentElement.scrollHeight - window.innerHeight;
      t = i <= 0 || window.scrollY / i * 100 > this.displayThreshold;
    }
    t ? (this.style.transform = "none", this.scrolledPast = !0) : (this.style.transform = "", this.scrolledPast = !1), this.floatingBtns.forEach(t => {
      t.style.setProperty("--sticky-atc-offset", this.scrolledPast ? this.offsetHeight + "px" : "0px");
    });
  }
  ["handleScrollBtn"]() {
    let t = document.querySelector("sticky-header"),
      x = t ? t.clientHeight : 0,
      e = this.scrollDestination.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({
      top: e - x - 15,
      behavior: "smooth"
    });
  }
  ["footerSpacing"]() {
    let t = document.querySelector(".sticky-atc-footer-spacer");
    if (t) return;
    (t = document.createElement("div")).className = "sticky-atc-footer-spacer", t.style.height = this.clientHeight - 1 + "px", t.style.display = "block";
    let x = document.querySelector(".footer");
    x && (t.style.background = window.getComputedStyle(x).background), document.body.appendChild(t);
  }
}
customElements.define("sticky-atc", StickyAtc);
class BundleDeals extends HTMLElement {
  constructor() {
    super(), this.productContainers = this.querySelectorAll(".bundle-deals__product-js"), this.mediaItemContainers = this.querySelectorAll(".bundle-deals__media-item-container-js"), this.mediaItemImgs = this.querySelectorAll(".bundle-deals__media-item-img-js"), this.checkboxes = this.querySelectorAll(".bundle-deals__checkbox-js"), this.variantPickers = this.querySelectorAll(".bundle-deals__variant-selects-js"), this.skipNonExistent = this.dataset.skipNonExistent === "true", this.skipUnavailable = "true" === this.dataset.skipUnavailable, this.prices = this.querySelectorAll(".bundle-deals__price-js"), this.comparePrices = this.querySelectorAll(".bundle-deals__compare-price-js"), this.totalPrice = this.querySelector(".bundle-deals__total-price-js"), this.totalComparePrice = this.querySelector(".bundle-deals__total-compare-price-js"), this.updatePrices = "true" === this.dataset.updatePrices, this.percentageLeft = parseFloat(this.dataset.percentageLeft), this.fixedDiscount = parseFloat(this.dataset.fixedDiscount), this.currencySymbol = this.dataset.currencySymbol, this.selectedVariants = {
      id_1: null,
      id_2: null,
      id_3: null,
      id_4: null,
      id_5: null
    }, this.formVariants = [], this.initIds(), this.checkboxes.forEach(t => {
      t.addEventListener("change", this.handleCheckboxChange.bind(this));
    }), this.variantPickers.forEach(t => {
      t.addEventListener("change", this.handleSelectChange.bind(this));
    });
  }
  ["initIds"]() {
    this.checkboxes.forEach(t => {
      this.selectedVariants[t.dataset.idIndex] = {
        id: t.dataset.id,
        price: t.dataset.price,
        comparePrice: t.dataset.comparePrice,
        basePrice: t.dataset.basePrice || t.dataset.price,
        multibuyEligible: t.dataset.multibuyEligible,
        checked: !0
      };
    }), this.updateFormIds();
  }
  ["handleCheckboxChange"]($) {
    let x = $.currentTarget,
      e = x.checked,
      i = parseInt(x.dataset.index);
    this.selectedVariants[x.dataset.idIndex].checked = e;
    let s = this.productContainers[i],
      a = s.querySelectorAll("select");
    e ? (this.mediaItemContainers[i].classList.remove("bundle-deals__media-item--disabled"), s.classList.remove("bundle-deals__product--deselected"), a.forEach($ => {
      $.removeAttribute("disabled");
    })) : (this.mediaItemContainers[i].classList.add("bundle-deals__media-item--disabled"), s.classList.add("bundle-deals__product--deselected"), a.forEach($ => {
      $.setAttribute("disabled", "");
    })), this.updateFormIds(), this.updatePrices && this.updateTotalPrice();
  }
  ["handleSelectChange"]($) {
    let x = $.currentTarget,
      e = parseInt(x.dataset.index),
      i = Array.from(x.querySelectorAll("select"), $ => $.value),
      s = JSON.parse(x.querySelector('[type="application/json"]').textContent).filter($ => x.querySelector(":checked").value === $.option1),
      a = [...x.querySelectorAll(".select--small")];
    updateVariantStatuses(s, a, this.skipUnavailable);
    let r = JSON.parse(x.querySelector('[type="application/json"]').textContent).find($ => !$.options.map(($, t) => i[t] === $).includes(!1));
    if (!r) {
      this.skipNonExistent && findAvailableVariant(x, i, !1, !0, this.skipUnavailable);
      return;
    }
    if (this.skipUnavailable && !r.available && findAvailableVariant(x, i, !1, !0, !0)) return;
    let {
      price: n,
      compare_at_price: l,
      featured_image: h
    } = r;
    n = parseInt(n);
    let c = l ? parseInt(l) : n,
      d = x.dataset.percentageLeft ?? 1,
      o = x.dataset.fixedDiscount ?? 0;
    n = n * d - o, h && (h = h.src);
    let f = r.id;
    this.selectedVariants[x.dataset.idIndex].basePrice = r.price;
    this.selectedVariants[x.dataset.idIndex].id = f, this.selectedVariants[x.dataset.idIndex].price = n, this.selectedVariants[x.dataset.idIndex].comparePrice = c, this.updateFormIds(), this.updatePrices && (window.GiftsboxlySecurity.writeHTML(this.prices[e], this.currencySymbol + (n / 100).toFixed(2), false), c > n ? window.GiftsboxlySecurity.writeHTML(this.comparePrices[e], this.currencySymbol + (c / 100).toFixed(2), false) : window.GiftsboxlySecurity.writeHTML(this.comparePrices[e], "", false), this.updateTotalPrice()), h && h.length > 0 && this.mediaItemImgs[e] && window.GiftsboxlySecurity.setResource(this.mediaItemImgs[e], "src", h);
  }
  ["updateFormIds"]() {
    let t = [],
      x = this.selectedVariants;
    for (let e in x) {
      let i = x[e];
      if (null != i && i.checked) {
        let s = t.findIndex($ => $.id === i.id);
        s < 0 ? t.unshift({
          id: i.id,
          quantity: 1
        }) : t[s].quantity += 1;
      }
    }
    this.formVariants = t;
  }
  updateTotalPrice() {
    if (!this.totalPrice || !this.totalComparePrice) return;
    if (this.dataset.multibuy === 'true' && window.GiftsboxlyMultibuy) {
      const selected = Object.values(this.selectedVariants).filter(item => item?.checked);
      const quantity = selected.filter(item => item.multibuyEligible === 'true').length;
      let total = 0, compare = 0;
      this.checkboxes.forEach((checkbox, index) => {
        const item = this.selectedVariants[checkbox.dataset.idIndex];
        const left = window.GiftsboxlyMultibuy.percentageLeft(checkbox, quantity, 1);
        const price = window.GiftsboxlyMultibuy.unitPrice(Number(item.basePrice), left);
        this.prices[index].textContent = this.currencySymbol + (price / 100).toFixed(2);
        this.comparePrices[index].textContent = Number(item.comparePrice) > price ? this.currencySymbol + (Number(item.comparePrice) / 100).toFixed(2) : '';
        if (item.checked) { total += price; compare += Number(item.comparePrice); }
      });
      this.totalPrice.textContent = this.currencySymbol + (total / 100).toFixed(2);
      this.totalComparePrice.textContent = compare > total ? this.currencySymbol + (compare / 100).toFixed(2) : '';
      return;
    }
    let t = [],
      x = [],
      e = this.selectedVariants;
    for (let i in e) {
      let s = e[i];
      null != s && s.checked && (t.push(parseInt(s.price)), x.push(parseInt(s.comparePrice)));
    }
    let a = t.reduce(($, t) => $ + t, 0),
      r = a * this.percentageLeft - this.fixedDiscount,
      n = x.reduce(($, t) => $ + t, 0);
    window.GiftsboxlySecurity.writeHTML(this.totalPrice, this.currencySymbol + (r / 100).toFixed(2), false), n > r ? window.GiftsboxlySecurity.writeHTML(this.totalComparePrice, this.currencySymbol + (n / 100).toFixed(2), false) : window.GiftsboxlySecurity.writeHTML(this.totalComparePrice, "", false);
  }
}
function _qbGetPresentmentRate($) {
  if (!$) return null;
  let x = window.Shopify;
  if (!x || !x.currency) return null;
  let e = x.currency.active,
    i = parseFloat(x.currency.rate);
  return e && i && 1 !== i && e !== $ ? i : null;
}
customElements.define("bundle-deals", BundleDeals);
class QuantityBreaks extends HTMLElement {
  constructor() {
    super(), this.quantityGifts = document.getElementById("quantity-gifts-" + this.dataset.section), this.quantityBreakUpsells = this.querySelectorAll("quantity-break-upsells"), this.subscriptionWidget = document.getElementById("SubscriptionWidget-" + this.dataset.section), this.inputs = this.querySelectorAll("input[name=\"quantity\"]"), this.labels = this.querySelectorAll(".quantity-break"), this.jsonData = this.querySelector('[type="application/json"]'), this.hasVariants = this.jsonData.dataset.hasVariants === "true", this.selectedVariants = {
      input_1: [],
      input_2: [],
      input_3: [],
      input_4: [],
      input_5: [],
      input_6: []
    }, this.updateUnavailable = this.dataset.updateUnavailable === "true", this.skipNonExistent = this.dataset.skipNonExistent === "true", this.skipUnavailable = this.dataset.skipUnavailable === "true", this.formVariants = [], this.selectedQuantity = 1, this.selectedOffer = 1;
    let t = this.querySelector("input[checked]");
    if (t && (this.selectedQuantity = parseInt(t.value), this.selectedOffer = parseInt(t.dataset.input.replace("input_", ""))), this.variantSelects = this.querySelectorAll(".quantity-break__selector-item"), this.updatePrices = this.dataset.updatePrices === "true", this.updatePdpPrices = this.dataset.updatePdpPrices === "true", this.moneyFormat = this.dataset.moneyFormat, this.subDiscount = 0, this.subDiscountType = null, this.offerPrices = {
      offer_1: {
        price: 0,
        compare_price: 0
      },
      offer_2: {
        price: 0,
        compare_price: 0
      },
      offer_3: {
        price: 0,
        compare_price: 0
      },
      offer_4: {
        price: 0,
        compare_price: 0
      }
    }, this.initOfferPrices(), this.dataset.currencyConversion === "true") {
      let x = _qbGetPresentmentRate(this.dataset.shopCurrency);
      x && (this.labels.forEach(t => {
        t.dataset.fixedDiscount && (t.dataset.fixedDiscount = String(Math.round(parseFloat(t.dataset.fixedDiscount) * x)));
      }), this.initOfferPrices());
    }
    this.preventGalleryScroll = this.dataset.preventGalleryScroll === "true", this.hasVariants && this.initVariants(), this.inputs.forEach(t => {
      t.addEventListener("change", this.handleChange.bind(this));
    }), this.variantSelects.forEach(t => {
      t.addEventListener("change", this.handleSelectChange.bind(this));
    }), this.subscriptionWidget && this.subscriptionWidget.displayedPrices !== "unit" && this.subscriptionWidget.renderSubTexts && this.subscriptionWidget.renderSubTexts();
  }
  applySubTo($) {
    return this.subDiscountType && $ ? this.subDiscountType === "fixed_amount" ? Math.max(0, $ - this.subDiscount) : this.subDiscountType === "percentage" ? Math.round($ * (100 - this.subDiscount) / 100) : "price" === this.subDiscountType ? this.subDiscount : $ : $;
  }
  discountUnitPrice(price, percentageLeft) {
    // Shopify allocates this percentage discount per unit, rounding the discount down to cents.
    if (!Number.isSafeInteger(price) || !Number.isFinite(Number(percentageLeft))) return NaN;
    const [coefficient, exponent = '0'] = String(percentageLeft).toLowerCase().split('e');
    const [whole, fraction = ''] = coefficient.split('.');
    const shift = Number(exponent) - fraction.length;
    const denominator = 10n ** BigInt(Math.max(0, -shift));
    const numerator = BigInt(whole + fraction) * 10n ** BigInt(Math.max(0, shift));
    const discount = BigInt(price) * (denominator - numerator);
    const roundedDiscount = discount / denominator - (discount < 0n && discount % denominator !== 0n ? 1n : 0n);
    return price - Number(roundedDiscount);
  }
  initOfferPrices() {
    let t = parseInt(this.dataset.basePrice);
    this.labels.forEach(x => {
      let i = x.dataset.input.replace("input_", ""),
        s = parseInt(x.dataset.quantity),
        a = window.GiftsboxlyMultibuy?.percentageLeft(this, s, x.dataset.percentageLeft) ?? x.dataset.percentageLeft,
        r = parseFloat(x.dataset.fixedDiscount),
        n = parseInt(x.dataset.baseComparePrice);
      this.offerPrices["offer_" + i].price = this.discountUnitPrice(t, a) * s - r, this.offerPrices["offer_" + i].compare_price = n * s;
    }), this.updatePdpPrices && this.updateDisplayedPdpPrices();
  }
  ["updateInnerPrices"]() {
    this.labels.forEach(t => {
      let e = t.dataset.input.replace("input_", ""),
        i = parseFloat(t.dataset.quantity),
        s = this.applySubTo(this.offerPrices["offer_" + e].price),
        a = this.offerPrices["offer_" + e].compare_price;
      this.updateLabelPrices(t, i, s, a);
    });
  }
  ["updateLabelPrices"]($, t, x, e) {
    let s = e - x,
      a = formatMoney(x, this.moneyFormat, !0),
      r = formatMoney(e, this.moneyFormat, !0),
      n = formatMoney(s, this.moneyFormat, !0),
      l = formatMoney(100 * Math.round(s / 100), this.moneyFormat, !0),
      h = formatMoney(x / t, this.moneyFormat, !0),
      c = formatMoney(e / t, this.moneyFormat, !0);
    $.querySelectorAll(".variant-price-update").forEach($ => {
      let e = $.dataset.text;
      if (this.dataset.multibuyEligible != null && $.classList.contains('quantity-break__benefit') && /GET\s+[\d.]+%\s+OFF/i.test(e)) {
        const left = window.GiftsboxlyMultibuy?.percentageLeft(this, t, 1) ?? 1;
        e = left < 1 ? e.replace(/GET\s+[\d.]+%\s+OFF/ig, 'GET ' + Math.round((1-left)*100) + '% OFF') : '';
        $.classList.toggle('hidden', left === 1);
      }
      e = (e = (e = (e = (e = (e = (e = e.replace("[quantity]", t)).replace("[price]", a)).replace("[compare_price]", r)).replace("[amount_saved]", n)).replace("[amount_saved_rounded]", l)).replace("[price_each]", h)).replace("[compare_price_each]", c), window.GiftsboxlySecurity.writeHTML($, e, false);
    });
    let d = $.querySelector(".quantity-break__compare-price");
    d && (e > x ? d.classList.remove("hidden") : d.classList.add("hidden"));
  }
  ["updateDisplayedPdpPrices"]() {
    let t = this.applySubTo(this.offerPrices["offer_" + this.selectedOffer].price),
      x = this.offerPrices["offer_" + this.selectedOffer].compare_price;
    updatePdpPrices(t, x, this.dataset.section, this.moneyFormat);
  }
  ["handleSelectChange"]($) {
    let x = $.currentTarget,
      e = Array.from(x.querySelectorAll("select"), $ => $.value);
    if (this.updateUnavailable) {
      let i = this.getVariantData().filter($ => x.querySelector(":checked").value === $.option1),
        s = [...x.querySelectorAll(".select--small")];
      updateVariantStatuses(i, s, this.skipUnavailable);
    }
    let a = this.getVariantData().find($ => {
      return !$.options.map(($, t) => e[t] === $).includes(!1);
    });
    if (!a) {
      this.skipNonExistent && findAvailableVariant(x, e, !1, !0, this.skipUnavailable);
      return;
    }
    if (this.skipUnavailable && !a.available && findAvailableVariant(x, e, !1, !0, !0)) return;
    x.dataset.selectedId = a.id;
    let r = x.dataset.selectIndex,
      n = x.closest(".quantity-break"),
      l = n.dataset.input;
    this.selectedVariants[l][r] = a.id, this.formVariants = this.selectedVariants[l], this.preventGalleryScroll || this.updateMedia(a);
    let h = x.querySelector(".quantity-break__selector-item__image img");
    if (h && window.GiftsboxlySecurity.setResource(h, "src", a.featured_image.src), !this.updatePrices) return;
    var c = 0,
      d = 0;
    let o = parseFloat(n.dataset.quantity),
      f = window.GiftsboxlyMultibuy?.percentageLeft(this, o, n.dataset.percentageLeft) ?? n.dataset.percentageLeft,
      u = parseFloat(n.dataset.fixedDiscount);
    var b = !0;
    n.dataset.compareMode === "price" && (b = !1);
    for (let p = 0; p < o; p++) {
      let _ = parseInt(this.selectedVariants[l][p]),
        m = this.getVariantData().find($ => parseInt($.id) === _);
      if (!m) return;
      c += this.discountUnitPrice(m.price, f), m.compare_at_price && b && m.compare_at_price > m.price ? d += m.compare_at_price : d += m.price;
    }
    c = c - u, this.offerPrices["offer_" + this.selectedOffer].price = c, this.offerPrices["offer_" + this.selectedOffer].compare_price = d, c = this.applySubTo(c), this.updateLabelPrices(n, o, c, d), this.updatePdpPrices && this.updateDisplayedPdpPrices(), this.subscriptionWidget && "unit" !== this.subscriptionWidget.displayedPrices && this.subscriptionWidget.renderSubTexts && this.subscriptionWidget.renderSubTexts();
  }
  ["getVariantData"]() {
    return this.variantData = this.variantData || JSON.parse(this.jsonData.textContent), this.variantData;
  }
  multibuyOfferPrice(label, subscription = this.subscriptionWidget?.isSubSelected) {
      const quantity = Number(label.dataset.quantity), key = label.dataset.input;
      const left = window.GiftsboxlyMultibuy.percentageLeft(this, quantity, label.dataset.percentageLeft, subscription);
      const ids = this.selectedVariants[key] || [];
      const variants = ids.map(id => this.getVariantData().find(variant => String(variant.id) === String(id)));
      const prices = variants.length === quantity && variants.every(Boolean) ? variants.map(variant => variant.price) : Array(quantity).fill(Number(this.dataset.basePrice));
      return prices.reduce((sum, price) => sum + this.discountUnitPrice(price, left), 0) - Number(label.dataset.fixedDiscount || 0);
  }
  refreshMultibuyPrices() {
    if (this.dataset.multibuyEligible == null) return;
    this.labels.forEach(label => {
      this.offerPrices['offer_' + label.dataset.input.replace('input_', '')].price = this.multibuyOfferPrice(label);
    });
    this.updateInnerPrices();
    if (this.updatePdpPrices) this.updateDisplayedPdpPrices();
    this.subscriptionWidget?.renderSubTexts?.();
  }
  ["initVariants"]() {
    this.hasVariants && (this.labels.forEach(t => {
      if (t.querySelector(".quantity-break__variants")) {
        let e = [];
        t.querySelectorAll(".quantity-break__selector-item").forEach($ => {
          e.push($.dataset.selectedId);
        }), this.selectedVariants[t.dataset.input] = e;
      }
    }), this.formVariants = []);
  }
  ["updateMedia"]($) {
    if (!$ || !$.featured_media) return;
    let x = document.querySelectorAll("[id^=\"MediaGallery-" + this.dataset.section + '"]');
    x.forEach(x => {
      x.setActiveMedia && x.setActiveMedia(this.dataset.section + "-" + $.featured_media.id, !0);
    });
  }
  ["handleChange"]($) {
    let x = parseInt($.target.value);
    this.selectedQuantity = x, this.selectedOffer = parseInt($.target.dataset.input.replace("input_", "")), this.hasVariants && (this.formVariants = this.selectedVariants[$.target.dataset.input]), this.quantityGifts && this.quantityGifts.unlockGifts(x), this.quantityBreakUpsells.forEach($ => {
      $.initUnlock();
    }), this.updatePdpPrices && this.updateDisplayedPdpPrices(), this.subscriptionWidget && this.subscriptionWidget.displayedPrices !== "unit" && this.subscriptionWidget.renderSubTexts && this.subscriptionWidget.renderSubTexts();
  }
}
customElements.define("quantity-breaks", QuantityBreaks);
class ShrineSubscriptionWidget extends HTMLElement {
  constructor() {
    super();
  }
  ["connectedCallback"]() {
    this.sectionId = this.dataset.section, this.productForm = document.getElementById("product-form-" + this.sectionId), this.isCheckbox = this.dataset.isCheckbox === "true", this.quantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section), this.oneTimeBox = this.querySelector("[data-type=\"one_time\"]"), this.oneTimeBoxTexts = this.querySelectorAll(".one-time-price-update"), this.subscriptionBox = this.querySelector("[data-type=\"subscription\"]"), this.frequencySelect = this.querySelector(".subscription__select .select__select"), this.frequencyRadios = this.querySelectorAll(".subscription__frequency-input"), this.subBoxTexts = this.querySelectorAll(".sub-price-update"), this.selectedPlanId = this.dataset.firstSellingPlanId, this.isSubSelected = this.dataset.preselected === "subscription", this.sellingPlanInput = null, this.subscriptionName = this.dataset.subscriptionName, this.basePrice = parseInt(this.dataset.basePrice), this.baseComparePrice = parseInt(this.dataset.baseComparePrice), this.updatePrices = this.dataset.updatePrices === "true", this.discountType = this.dataset.discountType, this.discountValue = parseInt(this.dataset.discountValue), this.displayedPrices = this.dataset.displayedPrices || "unit", this.moneyFormat = this.dataset.moneyFormat, this.quantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section), this.quantityBreaks && (this.quantityBreaks.updatePrices = !0, this.quantityBreaks.updatePdpPrices = !0), this.updatePrices && this.updateAllPrices(), this.init(), this.displayedPrices !== "unit" && this.quantityBreaks && this.quantityBreaks.offerPrices && (this.updatePricesFromQtyBreaks = !0, this.renderSubTexts());
  }
  ["init"]() {
    this.createSellingPlanInput(), this.setupBoxClickListeners(), this.setupFrequencyListeners();
  }
  ["createSellingPlanInput"]() {
    this.sellingPlanInput = document.createElement("input"), this.sellingPlanInput.type = "hidden", this.sellingPlanInput.name = "selling_plan", this.sellingPlanInput.value = this.isSubSelected ? this.selectedPlanId : "", this.productForm && this.productForm.appendChild(this.sellingPlanInput);
  }
  ["setupBoxClickListeners"]() {
    [this.oneTimeBox, this.subscriptionBox].forEach(t => {
      t && t.addEventListener("click", $ => {
        if (!(this.isCheckbox && $.target.closest(".subscription__frequency"))) {
          if (this.isCheckbox) {
            let i = t.classList.contains("subscription__box--selected");
            this.isSubSelected = !i, t.classList.toggle("subscription__box--selected"), t.dataset.selected = !i, this.sellingPlanInput.value = i ? "" : this.selectedPlanId;
          } else this.isSubSelected = "subscription" === t.dataset.type, this.oneTimeBox?.["classList"]["remove"]("subscription__box--selected"), this.subscriptionBox?.["classList"].remove("subscription__box--selected"), this.oneTimeBox?.["setAttribute"]("data-selected", "false"), this.subscriptionBox?.["setAttribute"]("data-selected", "false"), t.classList.add("subscription__box--selected"), t.dataset.selected = "true", this.sellingPlanInput.value = this.isSubSelected ? this.selectedPlanId : "";
          this.updatePrices && this.updateAllPrices();
        }
      });
    });
  }
  ["updateAllPrices"]() {
    if (this.quantityBreaks?.dataset.multibuyEligible != null) {
      this.quantityBreaks.subDiscountType = this.isSubSelected ? this.discountType : null;
      this.quantityBreaks.subDiscount = this.isSubSelected ? this.discountValue : 0;
      this.quantityBreaks.refreshMultibuyPrices();
    }
    if (this.basePrice = parseInt(this.dataset.basePrice), this.baseComparePrice = parseInt(this.dataset.baseComparePrice), this.quantityBreaks) this.isSubSelected ? (this.quantityBreaks.subDiscountType = this.discountType, this.quantityBreaks.subDiscount = this.discountValue) : (this.quantityBreaks.subDiscountType = null, this.quantityBreaks.subDiscount = 0), this.quantityBreaks.updateDisplayedPdpPrices(), this.quantityBreaks.updateInnerPrices();else {
      let t = this.applySubTo(this.basePrice);
      updatePdpPrices(t, this.baseComparePrice, this.dataset.section, this.moneyFormat);
    }
    let x = document.querySelector("variant-selects[data-section=\"" + this.sectionId + "\"][data-has-quantity-breaks-picker=\"true\"]");
    x && x.updateQuantityBreaksPickerPrices && x.updateQuantityBreaksPickerPrices(this.isSubSelected ? this.discountType : null, this.isSubSelected ? this.discountValue : 0, this.moneyFormat), this.renderSubTexts();
  }
  ["applySubTo"]($, t = !1) {
    if (this.isSubSelected || t) {
      if (this.discountType === "fixed_amount") return Math.max(0, $ - this.discountValue);
      if (this.discountType === "percentage") return Math.round($ * (100 - this.discountValue) / 100);
      if (this.discountType === "price") return this.discountValue;
    }
    return $;
  }
  ["setupFrequencyListeners"]() {
    this.frequencyRadios.forEach(t => {
      t.addEventListener("change", $ => {
        this.applyFrequencyNode($.currentTarget);
      });
    }), this.frequencySelect && this.frequencySelect.addEventListener("change", () => {
      let x = this.frequencySelect.selectedOptions?.[0];
      x && this.applyFrequencyNode(x);
    });
  }
  applyFrequencyNode($) {
    this.selectedPlanId = $.dataset.sellingPlanId, this.discountType = $.dataset.discountType || this.discountType, this.discountValue = $.dataset.discountValue ? parseInt($.dataset.discountValue, 10) : this.discountValue, this.subscriptionBox?.["classList"]["contains"]("subscription__box--selected") && (this.sellingPlanInput.value = this.selectedPlanId || ""), this.updatePrices && this.updateAllPrices();
  }
  computeSubPrices($ = !0) {
    let x = this.basePrice,
      e = this.baseComparePrice;
    this.quantityBreaks && "unit" !== this.displayedPrices && (x = this.quantityBreaks.offerPrices["offer_" + this.quantityBreaks.selectedOffer].price, e = this.quantityBreaks.offerPrices["offer_" + this.quantityBreaks.selectedOffer].compare_price, "unit_with_discount" == this.displayedPrices && (x /= this.quantityBreaks.selectedQuantity, e /= this.quantityBreaks.selectedQuantity)), $ && (x = this.applySubTo(x, !0));
    if (this.quantityBreaks?.dataset.multibuyEligible != null && this.displayedPrices !== 'unit' && window.GiftsboxlyMultibuy) {
      const label = Array.from(this.quantityBreaks.labels).find(label => label.dataset.input === 'input_' + this.quantityBreaks.selectedOffer);
      if (label) x = this.quantityBreaks.multibuyOfferPrice(label, $);
      if (this.displayedPrices === 'unit_with_discount') x /= this.quantityBreaks.selectedQuantity;
      if ($) x = this.applySubTo(x, true);
    }
    let i = this.subscriptionName,
      s = Math.max(0, e - x),
      a = e > 0 ? Math.round(100 * s / e) : 0;
    return {
      price: x,
      comparePrice: e,
      amount_saved: s,
      amount_saved_rounded: 100 * Math.round(s / 100),
      percentage_saved: a,
      subscription_name: i
    };
  }
  renderSubTexts() {
    if (this.subBoxTexts.length > 0) {
      let {
        price: t,
        compare_price: x,
        amount_saved: e,
        amount_saved_rounded: i,
        percentage_saved: s,
        subscription_name: a
      } = this.computeSubPrices();
      this.updatePriceTexts(this.subBoxTexts, t, x, e, i, s, a);
    }
    this.updatePricesFromQtyBreaks && this.renderOneTimeTexts();
  }
  ["renderOneTimeTexts"]() {
    if (this.oneTimeBoxTexts.length > 0) {
      let {
        price: t,
        compare_price: x,
        amount_saved: e,
        amount_saved_rounded: i,
        percentage_saved: s,
        subscription_name: a
      } = this.computeSubPrices(!1);
      this.updatePriceTexts(this.oneTimeBoxTexts, t, x, e, i, s, a);
    }
  }
  ["updatePriceTexts"]($, t, x, e, i, s, a) {
    let n = $ => formatMoney($, this.moneyFormat, !0);
    $.forEach($ => {
      let h = $.dataset.text || "";
      h = h.replaceAll("[price]", n(t)).replaceAll("[compare_price]", n(x)).replaceAll("[amount_saved]", n(e)).replaceAll("[amount_saved_rounded]", n(i)).replaceAll("[percentage_saved]", String(s) + "%").replaceAll("[subscription_name]", a || ""), window.GiftsboxlySecurity.writeHTML($, h, false), $.classList.contains("subscription__compare-price") && $.classList.toggle("hidden", !(x > t));
    });
  }
  ["hydrateFromExternalHTML"]($) {
    let x = $ => {
        let x = $.querySelector(".subscription__select .select__select"),
          e = $.querySelectorAll(".subscription__frequency-input");
        if (x) return {
          type: "select",
          count: x.options.length,
          index: x.selectedIndex >= 0 ? x.selectedIndex : 0
        };
        if (e.length) {
          let i = Array.from(e).findIndex($ => $.checked);
          return {
            type: "radio",
            count: e.length,
            index: i >= 0 ? i : 0
          };
        }
        return {
          type: "none",
          count: 0,
          index: 0
        };
      },
      e = x(this),
      i = this.isSubSelected;
    this.dataset.firstSellingPlanId = $.dataset.firstSellingPlanId ?? "", this.dataset.subscriptionName = $.dataset.subscriptionName ?? "", this.dataset.discountType = $.dataset.discountType ?? "", this.dataset.discountValue = $.dataset.discountValue ?? "0";
    let s = $.querySelector(".subscription__wrapper"),
      a = this.querySelector(".subscription__wrapper");
    s && a && a.replaceWith(s), this.oneTimeBox = this.querySelector('[data-type="one_time"]'), this.oneTimeBoxTexts = this.querySelectorAll(".one-time-price-update"), this.subscriptionBox = this.querySelector("[data-type=\"subscription\"]"), this.subBoxTexts = this.querySelectorAll(".sub-price-update"), this.frequencySelect = this.querySelector(".subscription__select .select__select"), this.frequencyRadios = this.querySelectorAll(".subscription__frequency-input");
    let r = x(this),
      n = 0;
    e.type !== "none" && r.type !== "none" && e.count === r.count && (n = Math.max(0, Math.min(e.index, r.count - 1))), r.type === "select" && this.frequencySelect ? this.frequencySelect.selectedIndex = n : r.type === "radio" && this.frequencyRadios.length && this.frequencyRadios.forEach(($, x) => {
      $.checked = x === n;
    });
    let l = null;
    this.frequencySelect ? l = this.frequencySelect.selectedOptions?.[0] || this.frequencySelect.options?.[0] || null : this.frequencyRadios.length && (l = Array.from(this.frequencyRadios).find($ => $.checked) || this.frequencyRadios[0]), this.selectedPlanId = l?.["dataset"]["sellingPlanId"] || this.dataset.firstSellingPlanId || "", l ? this.applyFrequencyNode(l) : (this.selectedPlanId = this.dataset.firstSellingPlanId || "", this.discountType = this.dataset.discountType || "", this.discountValue = parseInt(this.dataset.discountValue || "0", 10)), i && this.subscriptionBox ? (this.subscriptionBox.classList.add("subscription__box--selected"), this.subscriptionBox.setAttribute("data-selected", "true"), this.oneTimeBox?.["classList"].remove("subscription__box--selected"), this.oneTimeBox?.["setAttribute"]("data-selected", "false"), this.isSubSelected = !0, this.sellingPlanInput.value = this.selectedPlanId || "") : (this.subscriptionBox?.["classList"]["remove"]("subscription__box--selected"), this.subscriptionBox?.["setAttribute"]("data-selected", "false"), this.oneTimeBox && (this.oneTimeBox.classList.add("subscription__box--selected"), this.oneTimeBox.setAttribute("data-selected", "true")), this.isSubSelected = !1, this.sellingPlanInput.value = ""), this.setupBoxClickListeners(), this.setupFrequencyListeners(), this.updatePrices ? this.updateAllPrices() : this.renderSubTexts();
  }
}
function updatePdpPrices($, t, x, e) {
  let s = formatMoney($, e),
    a = formatMoney(t, e),
    r = t > $,
    n = document.querySelectorAll(".price-" + x);
  n.forEach(x => {
    if (x.classList.toggle("price--on-sale", r), window.GiftsboxlySecurity.writeHTML(x.querySelector(".price__regular .price-item--regular"), s, false), window.GiftsboxlySecurity.writeHTML(x.querySelector(".price__sale .price-item--sale"), s, false), r) {
      let l = x.querySelector(".price__sale .price-item--regular");
      l && window.GiftsboxlySecurity.writeHTML(l, a, false);
      let h = x.querySelector(".badge__percentage-saved");
      h && window.GiftsboxlySecurity.writeHTML(h, Math.round((t - $) * 100 / t), false);
      let c = x.querySelector(".badge__money-saved");
      if (c) {
        let d = formatMoney(t - $, e, !0);
        window.GiftsboxlySecurity.writeHTML(c, d, false);
      }
    }
  });
  let l = document.querySelectorAll(".main-atc-price-span-" + x);
  l.forEach($ => {
    window.GiftsboxlySecurity.writeHTML($, s, false);
  });
}
function updateVariantStatuses($, t, x = !1) {
  t.forEach((e, i) => {
    if (0 === i) return;
    let a = [...e.querySelectorAll("option")],
      r = t[i - 1].querySelector(":checked").value,
      n = $.filter($ => $.available && $["option" + i] === r).map($ => $["option" + (i + 1)]),
      l = $.filter($ => $["option" + i] === r).map($ => $["option" + (i + 1)]);
    a.forEach($ => {
      $.classList.remove("unavailable", "non-existent"), $.removeAttribute("disabled"), $.removeAttribute("hidden"), l.includes($.getAttribute("value")) ? n.includes($.getAttribute("value")) ? $.innerText = $.getAttribute("value") : ($.innerText = window.variantStrings.unavailable_with_option.replace("[value]", $.getAttribute("value")), $.classList.add("unavailable"), x && ($.setAttribute("disabled", ""), $.setAttribute("hidden", ""))) : ($.innerText = window.variantStrings.unavailable_with_option.replace("[value]", $.getAttribute("value")), $.classList.add("non-existent"), $.setAttribute("disabled", ""), $.setAttribute("hidden", ""));
    });
  });
}
function findAvailableVariant($, t, x = !0, e = !1, i = !1) {
  for (let a = t.length - 1; a >= 0; a--) {
    let r = x ? $.querySelector(".product-form__input:nth-child(" + (a + 1) + ")") : $.querySelectorAll(".select")[a],
      n = x ? r.querySelector(".product-form__input__type").dataset.type : "dropdown",
      l = "dropdown" === n ? r.querySelectorAll("option") : r.querySelectorAll("input[type=\"radio\"]"),
      h = Array.from(l).findIndex($ => $.value === t[a]),
      c = !1;
    for (; h < l.length - 1;) {
      h++;
      let d = l[h];
      if ((!e || !d.classList.contains("non-existent")) && (!i || !d.classList.contains("unavailable"))) {
        t[a] = d.value, c = !0;
        break;
      }
    }
    if (!c) for (h = Array.from(l).findIndex($ => $.value === t[a]); h > 0;) {
      h--;
      let o = l[h];
      if ((!e || !o.classList.contains("non-existent")) && (!i || !o.classList.contains("unavailable"))) {
        t[a] = o.value, c = !0;
        break;
      }
    }
    if (c) return n === "dropdown" ? r.querySelector(".select__select").value = t[a] : r.querySelector("input[type=\"radio\"][value=\"" + t[a] + '"]').checked = !0, $.dispatchEvent(new Event("change")), !0;
  }
  return !1;
}
function updateGiftGoalInStorage({
  giftHandle: $,
  giftVariantId: t,
  unlockType: x,
  unlockRequirement: e,
  unlockTarget: i
}) {
  let a = JSON.parse(localStorage.getItem(GIFTS_LOCAL_STORAGE_KEY)) || {};
  if (!$ || !t || !e || !x) return;
  let r = {
    type: x,
    gift_handle: $,
    gift_variant_id: Number(t),
    unlock_product_handle: i || null
  };
  x === "product_variant" ? Array.isArray(e) ? r.valid_variants = e.map($ => String($).toLowerCase().trim()) : r.valid_variants = [String(e).toLowerCase().trim()] : r.required_quantity = Number(e), a[$] = r, localStorage.setItem(GIFTS_LOCAL_STORAGE_KEY, JSON.stringify(a));
}
customElements.define("shrine-subscription-widget", ShrineSubscriptionWidget);
class QuantityGifts extends HTMLElement {
  constructor() {
    super(), this.gifts = this.querySelectorAll(".quantity-gift"), this.quantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section), this.quantitySelector = document.getElementById("Quantity-Form--" + this.dataset.section), this.unlockedItems = [], this.mainProduct = this.dataset.mainProduct, this.cartItems = document.querySelector("cart-drawer-items"), this.unlockBy = this.dataset.unlockBy === "variant" ? "variant" : "quantity", this.initUnlock(), this.saveLocalStorage = this.dataset.saveLocalStorage === "true", this.saveLocalStorage && this.unlockBy !== "variant" && this.storeLocalStorageData();
  }
  ["connectedCallback"]() {
    this.unlockBy === "variant" && (this._variantUnsub = subscribe(PUB_SUB_EVENTS.variantChange, ({
      data: t
    }) => {
      t && t.sectionId === this.dataset.section && this.unlockGiftsByVariant(t.variant, !1);
    }));
  }
  disconnectedCallback() {
    this._variantUnsub && (this._variantUnsub(), this._variantUnsub = void 0);
  }
  ["storeLocalStorageData"]() {
    this.gifts.forEach(t => {
      updateGiftGoalInStorage({
        giftHandle: t.dataset.handle,
        giftVariantId: t.dataset.product,
        unlockType: "product_quantity",
        unlockRequirement: t.dataset.quantity,
        unlockTarget: this.mainProduct
      });
    });
  }
  ["initUnlock"]() {
    if (this.unlockBy === "variant") {
      let t = this._readCurrentVariant();
      this.unlockGiftsByVariant(t, !0);
      return;
    }
    let x = 1,
      e = this.mainProduct ? document.querySelectorAll(".cart-item--product-" + this.mainProduct) : null;
    if (e && e.length) {
      x = 0;
      for (let i = 0; i < e.length; i++) x += parseInt(e[i].dataset.quantity);
    } else if (this.quantityBreaks) x = parseInt(this.quantityBreaks.selectedQuantity);else if (this.quantitySelector) {
      let s = this.quantitySelector.querySelector('input[name="quantity"]');
      x = parseInt(s.value);
    }
    this.unlockGifts(x, !0);
  }
  ["unlockGifts"]($, t = !1) {
    this.unlockBy !== "variant" && (this.unlockedItems = [], this.gifts.forEach(t => {
      if (parseInt(t.dataset.quantity) <= $) {
        t.classList.add("quantity-gift--unlocked"), t.dataset.unlocked = "true";
        let i = document.querySelector(".cart-item--product-" + t.dataset.handle);
        t.dataset.product && !i && this.unlockedItems.unshift(t.dataset.product);
      } else t.classList.remove("quantity-gift--unlocked"), t.dataset.unlocked = "false";
    }), this.mainProduct && t && this.addRemoveProducts());
  }
  ["_readCurrentVariant"]() {
    let t = document.querySelector("variant-selects[data-section=\"" + this.dataset.section + '"]');
    if (!t) return null;
    if (t.currentVariant) return t.currentVariant;
    let x = [];
    t.querySelectorAll(".product-form__input").forEach(t => {
      let i = t.querySelector(".product-form__input__type"),
        s = i ? i.dataset.type : null,
        a;
      if (s === "dropdown" || s === "dropdwon") {
        let r = t.querySelector(".select__select");
        a = r ? r.value : void 0;
      } else {
        let n = t.querySelector("input[type=\"radio\"]:checked");
        a = n ? n.value : void 0;
      }
      void 0 !== a && x.push(a);
    });
    try {
      let e = t.querySelector("[type=\"application/json\"]");
      if (!e) return null;
      let i = JSON.parse(e.textContent);
      return i.find(t => Array.isArray(t.options) && t.options.length === x.length && t.options.every(($, t) => $ === x[t])) || null;
    } catch (s) {
      return null;
    }
  }
  ["_getOptionOrders"]() {
    let t = document.querySelector('variant-selects[data-section="' + this.dataset.section + '"]');
    if (!t) return null;
    try {
      let x = t.querySelector("[type=\"application/json\"]");
      if (!x) return null;
      let e = JSON.parse(x.textContent),
        i = {
          option1: [],
          option2: [],
          option3: []
        };
      return e.forEach(t => {
        ["option1", "option2", "option3"].forEach($ => {
          let s = t[$];
          if (null != s) {
            let a = String(s).toLowerCase().trim();
            i[$].includes(a) || i[$].push(a);
          }
        });
      }), i;
    } catch (s) {
      return null;
    }
  }
  ["unlockGiftsByVariant"]($, t = !1) {
    if (this.unlockedItems = [], !$) {
      this.gifts.forEach($ => {
        $.classList.remove("quantity-gift--unlocked"), $.dataset.unlocked = "false", this.saveLocalStorage && removeLocalStorageGift({
          gift_handle: $.dataset.handle
        });
      }), this.mainProduct && t && this.addRemoveProducts();
      return;
    }
    let e = this._getOptionOrders(),
      i = {
        option1: $.option1 ? String($.option1).toLowerCase().trim() : null,
        option2: $.option2 ? String($.option2).toLowerCase().trim() : null,
        option3: $.option3 ? String($.option3).toLowerCase().trim() : null
      };
    this.gifts.forEach(t => {
      let a = (t.dataset.variant || "").toLowerCase().trim();
      if (!a.length) {
        t.classList.remove("quantity-gift--unlocked"), t.dataset.unlocked = "false", this.saveLocalStorage && removeLocalStorageGift({
          gift_handle: t.dataset.handle
        });
        return;
      }
      let r = !1,
        n = [];
      if (e) for (let l of ["option1", "option2", "option3"]) {
        let h = e[l],
          c = h.indexOf(a);
        if (-1 === c) continue;
        let d = i[l],
          o = d ? h.indexOf(d) : -1;
        o >= c && (r = !0, n = h.slice(c));
        break;
      }
      if (!e) {
        let f = [$.title, $.option1, $.option2, $.option3, ...(Array.isArray($.options) ? $.options : [])].filter($ => null != $).map($ => String($).toLowerCase().trim());
        r = f.includes(a), n = [a];
      }
      if (r) {
        t.classList.add("quantity-gift--unlocked"), t.dataset.unlocked = "true";
        let u = document.querySelector(".cart-item--product-" + t.dataset.handle);
        t.dataset.product && !u && this.unlockedItems.unshift(t.dataset.product), this.saveLocalStorage && updateGiftGoalInStorage({
          giftHandle: t.dataset.handle,
          giftVariantId: t.dataset.product,
          unlockType: "product_variant",
          unlockRequirement: n,
          unlockTarget: this.mainProduct
        });
      } else t.classList.remove("quantity-gift--unlocked"), t.dataset.unlocked = "false", this.saveLocalStorage && removeLocalStorageGift({
        gift_handle: t.dataset.handle
      });
    }), this.mainProduct && t && this.addRemoveProducts();
  }
  ["addRemoveProducts"]() {
    if (!this.mainProduct) return;
    let t = document.querySelectorAll(".cart-item--product-" + this.mainProduct);
    this.gifts.forEach(x => {
      t.length && x.dataset.unlocked === "true" && x.dataset.product ? this.addToCart(x) : this.removeFromCart(x);
    });
  }
  ["addToCart"]($) {
    let x = document.querySelector(".cart-item--product-" + $.dataset.handle);
    if (x) return;
    let e = $.querySelector("product-form");
    e && e.handleSubmit && e.handleSubmit();
  }
  ["removeFromCart"]($) {
    let x = document.querySelector(".cart-item--product-" + $.dataset.handle);
    x && this.cartItems && this.cartItems.updateQuantity(x.dataset.index, 0);
  }
}
customElements.define("quantity-gifts", QuantityGifts);
class QuantityBreakUpsells extends QuantityGifts {
  constructor() {
    super(), this.offerIndex = this.dataset.offer, this.upsells = this.querySelectorAll(".quantity-break__upsell"), this.boundToggleHandler = this.handleToggle.bind(this), this.upsells.forEach(t => {
      "true" === t.dataset.toggle && t.addEventListener("click", this.boundToggleHandler);
    }), this.initUnlock(), this.saveLocalStorage && this.storeLocalStorageData();
  }
  ["storeLocalStorageData"]() {
    this.upsells && this.upsells.forEach(t => {
      "gift" === t.dataset.type && updateGiftGoalInStorage({
        giftHandle: t.dataset.handle,
        giftVariantId: t.dataset.product,
        unlockType: "product_quantity",
        unlockRequirement: t.dataset.minQuantity,
        unlockTarget: this.dataset.mainProduct
      });
    });
  }
  ["disconnectedCallback"]() {
    this.upsells.forEach(t => {
      t.dataset.toggle === "true" && t.removeEventListener("click", this.boundToggleHandler);
    });
  }
  unlockGifts($, t = !1) {
    this.unlockedItems = [], this.upsells && (this.upsells.forEach(t => {
      let i = parseInt(t.dataset.minQuantity || 0),
        s = t.dataset.selected === "true",
        a = $ >= i && s;
      t.dataset.unlocked = a.toString(), t.classList.toggle("quantity-gift--unlocked", a);
      let r = document.querySelector(".cart-item--product-" + t.dataset.handle);
      if (a && t.dataset.product && !r) {
        let n = t.dataset.toggle === "true",
          l = t.dataset.selected === "true";
        (!n || n && l) && this.unlockedItems.unshift(t.dataset.product);
      }
    }), this.mainProduct && t && this.dataset.lastOffer === this.dataset.offer && this.addRemoveProducts());
  }
  addRemoveProducts() {
    if (!this.mainProduct) return;
    let t = document.querySelectorAll(".cart-item--product-" + this.mainProduct),
      x = [],
      e = [];
    this.upsells.forEach(i => {
      let a = document.querySelector(".cart-item--product-" + i.dataset.handle),
        r = i.dataset.unlocked === "true";
      t.length ? r && !a ? x.push(i) : !r && a && e.push(i) : a && e.push(i);
    }), e.length ? this.removeFromCart(e[0]) : x.length && this.addToCart(x[0]);
  }
  handleToggle($) {
    let x = $.currentTarget,
      e = "true" === x.dataset.selected;
    x.dataset.selected = (!e).toString(), this.syncUpsellAcrossOffers(x.dataset.handle, !e), this.syncCart(x.dataset.handle, !e, x);
  }
  syncUpsellAcrossOffers($, t) {
    let e = document.querySelectorAll("quantity-break-upsells");
    e.forEach(e => {
      e.querySelectorAll(".quantity-break__upsell[data-handle=\"" + $ + '"]').forEach($ => {
        $.dataset.selected = t.toString();
      });
    });
  }
  ["syncCart"]($, t, x) {
    let i = document.querySelector(".cart-item--product-" + $);
    this.cartItems && (t && !i ? this.addToCart(x) : !t && i && this.removeFromCart(x));
  }
}
customElements.define("quantity-break-upsells", QuantityBreakUpsells);
class ProductInfoUpsell extends HTMLElement {
  constructor() {
    super(), this.image = this.querySelector(".upsell__image__img"), this.toggleBtn = this.querySelector(".upsell-toggle-btn"), this.variantSelects = this.querySelector(".upsell__variant-picker"), this.variantSelectElements = this.querySelectorAll(".select__select"), this.jsonData = this.querySelector("[type=\"application/json\"]"), this.productForm = this.querySelector("product-form"), this.productForm && (this.idInput = this.productForm.querySelector('[name="id"]')), this.skipNonExistent = this.dataset.skipNonExistent === "true", this.skipUnavailable = this.dataset.skipUnavailable === "true", this.updatePrices = "true" === this.dataset.updatePrices, this.updatePrices && (this.price = parseInt(this.dataset.price), this.comparePrice = parseInt(this.dataset.comparePrice), this.priceSpan = this.querySelector(".upsell__price .regular-price"), this.comparePriceSpan = this.querySelector(".upsell__price .compare-price"), this.percentageLeft = parseFloat(this.dataset.percentageLeft), this.fixedDiscount = parseFloat(this.dataset.fixedDiscount), this.moneyFormat = this.dataset.moneyFormat, this.isMainOfferItem = this.dataset.mainOfferItem === "true", this.isMainOfferItem && (this.mainOfferContainer = document.querySelector("#MainBundleOffer-" + this.dataset.section))), this.toggleBtn && this.toggleBtn.addEventListener("click", this.handleToggle.bind(this)), this.variantSelects && this.variantSelects.addEventListener("change", this.handleSelectChange.bind(this));
  }
  ["handleToggle"]($) {
    $.target.nodeName.toLowerCase() !== "select" && "option" !== $.target.nodeName.toLowerCase() && (this.dataset.selected === "true" ? this.dataset.selected = "false" : this.dataset.selected = "true");
  }
  ["handleSelectChange"]($) {
    let x = $.currentTarget,
      e = Array.from(x.querySelectorAll("select"), $ => $.value),
      i = this.getVariantData().find($ => {
        return !$.options.map(($, t) => e[t] === $).includes(!1);
      }),
      s = this.getVariantData().filter($ => x.querySelector(":checked").value === $.option1),
      a = [...x.querySelectorAll("select")];
    if (updateVariantStatuses(s, a, this.skipUnavailable), !i) {
      this.skipNonExistent && findAvailableVariant(x, e, !1, !0, this.skipUnavailable);
      return;
    }
    !(this.skipUnavailable && !i.available && findAvailableVariant(x, e, !1, !0, !0)) && (this.updatePrices && (this.price = i.price * this.percentageLeft - this.fixedDiscount, this.comparePrice = i.price, i.compare_at_price && i.compare_at_price > i.price && (this.comparePrice = i.compare_at_price), displayPrices(this.price, this.comparePrice, this.priceSpan, this.comparePriceSpan, this.moneyFormat)), this.image && i.featured_image && window.GiftsboxlySecurity.setResource(this.image, "src", i.featured_image.src), this.updateId(i.id), this.isMainOfferItem && this.mainOfferContainer.updateTotalPrices && this.mainOfferContainer.updateTotalPrices());
  }
  ["updateId"]($) {
    this.dataset.id = $, this.idInput && (this.idInput.value = $);
  }
  ["getVariantData"]() {
    return this.variantData = this.variantData || JSON.parse(this.jsonData.textContent), this.variantData;
  }
}
customElements.define("product-info-upsell", ProductInfoUpsell);
class CartDrawerUpsell extends ProductInfoUpsell {
  constructor() {
    super(), this.cartDrawer = document.querySelector("cart-drawer"), this.cartItems = this.cartDrawer ? this.cartDrawer.querySelector("cart-drawer-items") : null, this.classicAddButton = this.querySelector(".upsell__add-btn");
  }
  ["handleToggle"]($) {
    "select" !== $.target.nodeName.toLowerCase() && $.target.nodeName.toLowerCase() !== "option" && (this.dataset.selected === "true" ? (this.dataset.selected = "false", this.removeFromCart()) : (this.dataset.selected = "true", this.addToCart()));
  }
  ["addRemoveFromCart"]() {
    this.dataset.selected !== "true" || this.cartDrawer.classList.contains("is-empty") ? this.removeFromCart() : this.addToCart();
  }
  addToCart() {
    let t = this.cartDrawer.querySelector(".cart-item--product-" + this.dataset.handle);
    t || (this.toggleBtn && this.toggleBtn.setAttribute("disabled", ""), this.variantSelectElements.forEach(t => {
      t.setAttribute("disabled", "");
    }), this.productForm.handleSubmit());
  }
  ["removeFromCart"]() {
    let t = this.cartDrawer.querySelector(".cart-item--product-" + this.dataset.handle);
    t && this.cartItems && (this.toggleBtn && this.toggleBtn.setAttribute("disabled", ""), this.variantSelectElements.forEach($ => {
      $.setAttribute("disabled", "");
    }), this.cartItems.updateQuantity(t.dataset.index, 0));
  }
  ["updateId"]($) {
    if (this.dataset.id = $, this.idInput.value = $, !this.classicAddButton && this.dataset.selected === "true") {
      this.selectTimeout && clearTimeout(this.selectTimeout), this.removeFromCart();
      let x = $ => {
        $.detail.handle === "handle" && (this.addToCart(), document.removeEventListener("cartQuantityUpdated", x));
      };
      document.addEventListener("cartQuantityUpdated", x);
    }
  }
  getUpdateRequired() {
    let t = this.cartDrawer.querySelector(".cart-item--product-" + this.dataset.handle),
      x = !1;
    return t && this.dataset.selected === "false" ? x = !0 : t || this.dataset.selected !== "true" || (x = !0), x;
  }
}
function displayPrices($, t, x, e, i) {
  if (i) {
    if ($ && x) {
      var a = formatMoney($, i);
      window.GiftsboxlySecurity.writeHTML(x, a, false);
    }
    if (t && e) {
      var r = formatMoney(t, i);
      window.GiftsboxlySecurity.writeHTML(e, r, false), t > $ ? e.classList.remove("hidden") : e.classList.add("hidden");
    }
  }
}
function formatMoney($, t, x = !1) {
  "string" == typeof $ && ($ = $.replace(".", ""));
  var i = "",
    s = /\{\{\s*(\w+)\s*\}\}/,
    a = t;
  function r($, t) {
    return typeof $ == "undefined" ? t : $;
  }
  function n($, t, e, i) {
    if (t = r(t, 2), e = r(e, ","), i = r(i, "."), isNaN($) || null == $) return 0;
    var a = ($ = ($ / 100).toFixed(t)).split("."),
      n = a[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + e),
      l = a[1] ? i + a[1] : "";
    return x && l === i + "00" && (l = ""), n + l;
  }
  switch (a.match(s)[1]) {
    case "amount":
      i = n($, 2);
      break;
    case "amount_no_decimals":
      i = n($, 0);
      break;
    case "amount_with_comma_separator":
      i = n($, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      i = n($, 0, ".", ",");
  }
  return a.replace(s, i);
}
customElements.define("cart-drawer-upsell", CartDrawerUpsell);
class CartDrawerGift extends CartDrawerUpsell {
  constructor() {
    super(), this.saveLocalStorage = "true" === this.dataset.saveLocalStorage, this.saveLocalStorage && this.storeLocalStorageData();
  }
  ["storeLocalStorageData"]() {
    this.dataset.handle && this.dataset.id && this.dataset.mainProduct && this.dataset.requirement && this.dataset.type && updateGiftGoalInStorage({
      giftHandle: this.dataset.handle,
      giftVariantId: this.dataset.id,
      unlockType: this.dataset.type,
      unlockRequirement: Number(this.dataset.requirement),
      unlockTarget: this.dataset.mainProduct
    });
  }
}
function initToggleUpsells() {
  let t = document.querySelector("cart-drawer");
  t && t.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift").forEach(t => {
    t.addRemoveFromCart && t.addRemoveFromCart();
  });
}
customElements.define("cart-drawer-gift", CartDrawerGift), initToggleUpsells();
class MainBundleOffer extends HTMLElement {
  constructor() {
    super(), this.offerItems = this.querySelectorAll(".main-offer-item"), this.updatePrices = this.dataset.updatePrices === "true", this.updatePrices && (this.priceSpan = this.querySelector(".bundle-deals__total-price-js"), this.comparePriceSpan = this.querySelector(".bundle-deals__total-compare-price-js"), this.percentageLeft = parseFloat(this.dataset.percentageLeft), this.fixedDiscount = parseFloat(this.dataset.fixedDiscount), this.moneyFormat = this.dataset.moneyFormat);
  }
  ["updateTotalPrices"]() {
    if (this.updatePrices) {
      var t = 0,
        x = 0;
      for (let e = 0; e < this.offerItems.length; e++) t += parseInt(this.offerItems[e].price), x += parseInt(this.offerItems[e].comparePrice);
      t = t * this.percentageLeft - this.fixedDiscount, displayPrices(t, x, this.priceSpan, this.comparePriceSpan, this.moneyFormat);
    }
  }
}
customElements.define("main-bundle-offer", MainBundleOffer);
class CustomProductField extends HTMLElement {
  constructor() {
    super();
  }
  ["connectedCallback"]() {
    this.fieldName = this.dataset.name, this.input = this.querySelector("[type=\"text\"], [type=\"number\"], textarea"), this.inputRadios = this.querySelectorAll("[type=\"radio\"]"), this.select = this.querySelector(".select__select"), this.productForm = document.getElementById("product-form-" + this.dataset.section), this.prevValue = this.dataset.defaultValue, this.isRequired = this.dataset.required === "true", this.isText = !0, this.notMain = this.dataset.notMain === "true", ("select" === this.dataset.type || "pills" === this.dataset.type) && (this.isText = !1), this.createInputs(), this.isRequired && this.isText && (this.isValid = !0, this.atcButtons = this.notMain ? document.querySelectorAll(".featured-product-atc-" + this.dataset.section) : document.querySelectorAll(".main-product-atc"), this.mainAtcButton = this.productForm.querySelector("#ProductSubmitButton-" + this.dataset.section), this.mainAtcBtnLabel = this.mainAtcButton.querySelector(".main-atc__label"), this.mainAtcBtnError = this.mainAtcButton.querySelector(".main-atc__error"), this.atcErrorMsg = this.dataset.atcErrorMsg, this.mainAtcButton.dataset.requiredFields = parseInt(this.mainAtcButton.dataset.requiredFields) + 1, this.mainAtcBtnError && window.GiftsboxlySecurity.writeHTML(this.mainAtcBtnError, this.atcErrorMsg, false), this.applyStickyAtcError = this.dataset.applyStickyAtcError === "true", this.stickyAtcButton = document.querySelector("#sticky-atc-" + this.dataset.section), this.applyStickyAtcError && this.stickyAtcButton && (this.stickyAtcBtnLabel = this.stickyAtcButton.querySelector(".sticky-atc__label"), this.stickyAtcBtnError = this.stickyAtcButton.querySelector(".sticky-atc__error"), this.stickyAtcBtnError && window.GiftsboxlySecurity.writeHTML(this.stickyAtcBtnError, this.atcErrorMsg, false)), this.validateValue(this.prevValue, null)), this.input && this.input.addEventListener("input", this.handleChange.bind(this)), this.inputRadios.forEach(t => {
      t.addEventListener("input", this.handleChange.bind(this));
    }), this.select && this.select.addEventListener("change", this.handleChange.bind(this));
  }
  handleChange($) {
    let x = $.target.value.trim();
    if ($.target.checkValidity()) this.prevValue = x;else {
      $.target.value = this.prevValue;
      return;
    }
    this.dataset.value = x, this.productFormInput.value = x, this.isRequired && this.isText && this.validateValue(x, $.target);
  }
  validateValue($, t) {
    let e = $.length > 0;
    if (e === this.isValid) return;
    this.isValid = e, t && (this.isValid ? (t.classList.remove("input--error"), this.mainAtcButton.dataset.validFields = parseInt(this.mainAtcButton.dataset.validFields) + 1) : (t.classList.add("input--error"), this.mainAtcButton.dataset.validFields = parseInt(this.mainAtcButton.dataset.validFields) - 1));
    let i = this.mainAtcButton.dataset.validFields === this.mainAtcButton.dataset.requiredFields,
      s = this.mainAtcButton.dataset.unavailable === "true";
    this.atcButtons.forEach($ => {
      i && !s ? $.removeAttribute("disabled") : $.setAttribute("disabled", "");
    }), 0 !== this.atcErrorMsg.length && (i ? (this.mainAtcBtnLabel.style.display = "", this.mainAtcBtnError.style.display = "none", this.applyStickyAtcError && this.stickyAtcButton && (this.stickyAtcBtnLabel.style.display = "", this.stickyAtcBtnError.style.display = "none")) : (this.mainAtcBtnLabel.style.display = "none", this.mainAtcBtnError.style.display = "", this.applyStickyAtcError && this.stickyAtcButton && (this.stickyAtcBtnLabel.style.display = "none", this.stickyAtcBtnError.style.display = "")));
  }
  createInputs() {
    this.productFormInput = document.createElement("input"), this.productFormInput.setAttribute("type", "hidden"), this.productFormInput.setAttribute("name", "properties[" + this.fieldName + "]"), this.productFormInput.value = this.dataset.defaultValue, this.productFormInput.classList.add("shrine-property-input"), this.productForm.appendChild(this.productFormInput);
  }
}
customElements.define("custom-product-field", CustomProductField);
class VariantSelects extends HTMLElement {
  constructor() {
    super(), this.secondarySelectSelector = "StickyAtcVariantPicker-", this.secondarySelect = document.getElementById("" + this.secondarySelectSelector + this.dataset.section), this.isSecondary = !1, this.QuantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section), this.hasQuantityBreaksPicker = this.dataset.hasQuantityBreaksPicker === "true", this.prependMedia = this.dataset.disablePrepend != "true", this.filtering = this.dataset.hasFiltering === "true", this.skipNonExistent = "true" === this.dataset.skipNonExistent, this.skipUnavailable = this.dataset.skipUnavailable === "true", this.hasQuantityBreaksPicker && (this.quantityBreaksPickerStyle = this.dataset.quantityBreaksPickerStyle, this.quantityBreaksPickerDisplayedImages = this.dataset.quantityBreaksPickerDisplayedImages), this.addEventListener("change", this.onVariantChange);
  }
  onVariantChange() {
    if (this.updateOptions(), this.updateMasterId(), this.toggleAddButton(!0, "", !1), this.updatePickupAvailability(), this.removeErrorMessage(), this.updateVariantStatuses(), this.currentVariant) {
      if (this.skipUnavailable && !this.currentVariant.available && findAvailableVariant(this, this.options, !0, !0, !0)) return;
      this.updateMedia(), this.updateURL(), this.updateVariantInput(), this.renderProductInfo(), this.updateShareUrl();
    } else {
      if (this.toggleAddButton(!0, "", !0), this.skipNonExistent && findAvailableVariant(this, this.options, !0, !0, this.skipUnavailable)) return;
      this.setUnavailable();
    }
  }
  ["updateOptions"]() {
    let t = [];
    this.querySelectorAll(".product-form__input").forEach(x => {
      let i,
        s = x.querySelector(".product-form__input__type").dataset.type;
      i = s == "dropdown" || s == "dropdwon" ? x.querySelector(".select__select").value : x.querySelector("input[type=\"radio\"]:checked").value, t.push(i);
    }), this.options = t;
  }
  ["updateMasterId"]() {
    this.currentVariant = this.getVariantData().find(t => {
      return !t.options.map(($, t) => this.options[t] === $).includes(!1);
    });
  }
  ["updateMedia"]() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;
    let t = document.querySelectorAll("[id^=\"MediaGallery-" + this.dataset.section + '"]');
    t.forEach(t => t.setActiveMedia(this.dataset.section + "-" + this.currentVariant.featured_media.id, this.prependMedia, this.filtering, this.currentVariant));
    let x = document.querySelector("#ProductModal-" + this.dataset.section + " .product-media-modal__content");
    if (!x) return;
    let e = x.querySelector('[data-media-id="' + this.currentVariant.featured_media.id + '"]');
    x.prepend(e);
  }
  ["updateURL"]() {
    this.currentVariant && this.dataset.updateUrl !== "false" && window.history.replaceState({}, "", this.dataset.url + "?variant=" + this.currentVariant.id);
  }
  ["updateShareUrl"]() {
    let t = document.getElementById("Share-" + this.dataset.section);
    t && t.updateUrl && t.updateUrl("" + window.shopUrl + this.dataset.url + "?variant=" + this.currentVariant.id);
  }
  ["updateVariantInput"]() {
    let t = document.querySelectorAll("#product-form-" + this.dataset.section + ", #product-form-installment-" + this.dataset.section);
    t.forEach(t => {
      let e = t.querySelector("input[name=\"id\"]");
      e.value = this.currentVariant.id, e.dispatchEvent(new Event("change", {
        bubbles: !0
      }));
    });
  }
  ["updateVariantStatuses"]() {
    let t = this.variantData.filter(t => this.querySelector(":checked").value === t.option1),
      x;
    (x = this.isSecondary && this.secondarySelect ? [...this.secondarySelect.querySelectorAll(".product-form__input")] : [...this.querySelectorAll(".product-form__input")]).forEach((e, i) => {
      if (0 === i) return;
      let a = [...e.querySelectorAll("input[type=\"radio\"], .select__select option")],
        r = x[i - 1].querySelector(":checked").value,
        n = t.filter($ => $.available && $["option" + i] === r).map($ => $["option" + (i + 1)]),
        l = t.filter($ => $["option" + i] === r).map($ => $["option" + (i + 1)]);
      this.setInputAvailability(a, n, l, this.skipNonExistent, this.skipUnavailable);
    });
  }
  ["setInputAvailability"]($, t, x, e = !1, i = !1) {
    $.forEach($ => {
      $.classList.remove("unavailable", "non-existent", "disabled"), $.removeAttribute("disabled"), $.removeAttribute("hidden");
      let r = $.getAttribute("value"),
        n = null;
      "true" === $.dataset.swatch && (n = $.closest(".color-swatch")), n && n.classList.remove("unavailable", "non-existent", "disabled"), x.includes(r) ? t.includes(r) ? "OPTION" === $.nodeName ? $.innerText = r : ($.classList.remove("disabled"), n && n.classList.remove("disabled")) : $.nodeName === "OPTION" ? ($.innerText = window.variantStrings.unavailable_with_option.replace("[value]", r), $.classList.add("unavailable"), i && ($.setAttribute("disabled", ""), $.setAttribute("hidden", ""))) : ($.classList.add("disabled", "unavailable"), n && n.classList.add("disabled", "unavailable")) : $.nodeName === "OPTION" ? ($.innerText = window.variantStrings.unavailable_with_option.replace("[value]", r), $.classList.add("non-existent"), e && ($.setAttribute("disabled", ""), $.setAttribute("hidden", ""))) : ($.classList.add("disabled", "non-existent"), n && n.classList.add("disabled", "non-existent"));
    });
  }
  ["updatePickupAvailability"]() {
    let t = document.querySelector("pickup-availability");
    t && (this.currentVariant && this.currentVariant.available ? t.fetchAvailability && t.fetchAvailability(this.currentVariant.id) : (t.removeAttribute("available"), window.GiftsboxlySecurity.writeHTML(t, "", false)));
  }
  ["removeErrorMessage"]() {
    let t = this.closest("section");
    if (!t) return;
    let x = t.querySelector("product-form");
    x && x.handleErrorMessage();
  }
  renderProductInfo() {
    let t = this.currentVariant.id,
      x = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    window.GiftsboxlySecurity.request(this.dataset.url + "?variant=" + t + "&section_id=" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)).then(t => t.text()).then(e => {
      if (this.currentVariant.id !== t) return;
      let s = new DOMParser().parseFromString(window.GiftsboxlySecurity.sanitizeHTML(e), "text/html"),
        a = document.getElementById("price-" + this.dataset.section),
        r = s.getElementById("price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)),
        n = document.getElementById("sticky-atc-separate-price-" + this.dataset.section),
        l = s.getElementById("sticky-atc-separate-price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)),
        h = document.getElementById("sticky-atc-price-" + this.dataset.section),
        c = s.getElementById("sticky-atc-price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)),
        d = document.getElementById("sticky-atc-image-" + this.dataset.section);
      d && this.currentVariant.featured_image && window.GiftsboxlySecurity.setResource(d, "src", this.currentVariant.featured_image.src);
      let o = document.getElementById("main-atc-price-" + this.dataset.section),
        f = s.getElementById("main-atc-price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)),
        u = document.querySelectorAll("[id^=\"custom-label-" + this.dataset.section + '"]'),
        b = s.querySelectorAll("[id^=\"custom-label-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section) + '"]'),
        p = s.getElementById("Sku-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)),
        _ = document.getElementById("Sku-" + this.dataset.section),
        m = s.getElementById("Inventory-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)),
        y = document.getElementById("Inventory-" + this.dataset.section);
      if (a && r && window.GiftsboxlySecurity.writeHTML(a, r.innerHTML, false), n && l && window.GiftsboxlySecurity.writeHTML(n, l.innerHTML, false), h && c && window.GiftsboxlySecurity.writeHTML(h, c.innerHTML, false), f && o && window.GiftsboxlySecurity.writeHTML(o, f.innerHTML, false), u && b) for (var g = 0; g < u.length; g++) window.GiftsboxlySecurity.writeHTML(u[g], b[g].innerHTML, false);
      if (m && y && window.GiftsboxlySecurity.writeHTML(y, m.innerHTML, false), p && _ && (window.GiftsboxlySecurity.writeHTML(_, p.innerHTML, false), _.classList.toggle("visibility-hidden", p.classList.contains("visibility-hidden"))), this.QuantityBreaks) {
        let v = s.getElementById("quantity-breaks-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)),
          S = this.QuantityBreaks.querySelectorAll(".dynamic-price"),
          k = v.querySelectorAll(".dynamic-price");
        for (let T = 0; T < S.length; T++) window.GiftsboxlySecurity.writeHTML(S[T], k[T].innerHTML, false);
        if (this.QuantityBreaks.hasVariants) {
          this.QuantityBreaks.variantSelects.forEach($ => {
            $.dataset.selectedId = this.currentVariant.id;
          });
          let E = this.QuantityBreaks.querySelectorAll(".quantity-break__variant-select"),
            B = v.querySelectorAll(".quantity-break__variant-select");
          for (let C = 0; C < E.length; C++) window.GiftsboxlySecurity.writeHTML(E[C], B[C].innerHTML, false);
          this.QuantityBreaks.initVariants();
        }
        this.currentVariant.featured_image && this.QuantityBreaks.querySelectorAll(".quantity-break__selector-item__image img").forEach($ => {
          window.GiftsboxlySecurity.setResource($, "src", this.currentVariant.featured_image.src);
        }), this.QuantityBreaks.updatePdpPrices && (this.QuantityBreaks.dataset.basePrice = v.dataset.basePrice, this.QuantityBreaks.labels.forEach($ => {
          $.dataset.baseComparePrice = v.querySelector("label[data-input=\"" + $.dataset.input + '"]').dataset.baseComparePrice;
        }), this.QuantityBreaks.initOfferPrices(!0), this.QuantityBreaks.updateInnerPrices());
      }
      let q = document.getElementById("SubscriptionWidget-" + this.dataset.section),
        I = s.getElementById("SubscriptionWidget-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
      if (q) {
        if (I) {
          q.dataset.basePrice = I.dataset.basePrice || "", q.dataset.baseComparePrice = I.dataset.baseComparePrice || "";
          let P = (q.dataset.firstSellingPlanId || "") !== (I.dataset.firstSellingPlanId || "");
          if (P && typeof q.hydrateFromExternalHTML === "function") q.hydrateFromExternalHTML(I);else {
            let w = q.querySelectorAll(".one-time-price-update"),
              R = I.querySelectorAll(".one-time-price-update");
            for (let A = 0; A < w.length; A++) window.GiftsboxlySecurity.writeHTML(w[A], R[A].innerHTML, false);
            q.updatePrices && q.updateAllPrices();
          }
        } else q.classList.add("hidden");
      }
      if (this.hasQuantityBreaksPicker) {
        let U = s.getElementById("variant-selects-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)),
          F = this.querySelectorAll(".dynamic-price"),
          L = U.querySelectorAll(".dynamic-price");
        for (let V = 0; V < F.length; V++) window.GiftsboxlySecurity.writeHTML(F[V], L[V].innerHTML, false);
        if ("vertical" === this.quantityBreaksPickerStyle && this.quantityBreaksPickerDisplayedImages === "variant_images") {
          let D = this.querySelectorAll(".quantity-break__image img"),
            M = U.querySelectorAll(".quantity-break__image img");
          for (let Q = 0; Q < D.length; Q++) window.GiftsboxlySecurity.setResource(D[Q], "src", M[Q].src);
        }
        let G = U.querySelectorAll(".quantity-break[data-base-price]"),
          H = this.querySelectorAll(".quantity-break");
        for (let N = 0; N < H.length && N < G.length; N++) G[N].dataset.basePrice && (H[N].dataset.basePrice = G[N].dataset.basePrice, H[N].dataset.baseComparePrice = G[N].dataset.baseComparePrice);
        let O = document.getElementById("SubscriptionWidget-" + this.dataset.section);
        O && O.isSubSelected && this.updateQuantityBreaksPickerPrices && this.updateQuantityBreaksPickerPrices(O.discountType, O.discountValue, O.moneyFormat);
      }
      if (this.secondarySelect) {
        let W = s.getElementById("" + this.secondarySelectSelector + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
        W && window.GiftsboxlySecurity.writeHTML(this.secondarySelect, W.innerHTML, false);
      }
      let X = document.getElementById("price-" + this.dataset.section);
      X && X.classList.remove("visibility-hidden"), this.dataset.options = this.currentVariant.options.join(","), y && y.classList.toggle("visibility-hidden", "" === m.innerText);
      let Z = s.getElementById("ProductSubmitButton-" + x);
      this.toggleAddButton(!Z || Z.hasAttribute("disabled"), window.variantStrings.soldOut), publish(PUB_SUB_EVENTS.variantChange, {
        data: {
          sectionId: x,
          html: s,
          variant: this.currentVariant
        }
      });
    });
  }
  ["toggleAddButton"]($ = !0, t, x = !0) {
    let i = document.getElementById("product-form-" + this.dataset.section);
    if (!i) return;
    let s = i.querySelector("[name=\"add\"]");
    if (!s) return;
    let a = document.querySelectorAll(".main-product-atc");
    var r = i.querySelector(".main-atc__label__text");
    r || (r = i.querySelector(".main-atc__label"));
    let n = i.querySelector(".main-atc-price"),
      l = document.querySelector(".sticky-atc__add_button"),
      h = null,
      c = null;
    if (l && (h = l.querySelector(".sticky-atc__label__text"), c = l.querySelector(".sticky-atc__button-price")), $) s.setAttribute("disabled", "disabled"), s.setAttribute("data-unavailable", "true"), t && r && (r.textContent = t), t && h && l.dataset.label && (h.textContent = t), a.forEach($ => {
      $.setAttribute("disabled", "disabled");
    }), n && n.classList.add("hidden"), c && c.classList.add("hidden");else {
      s.setAttribute("data-unavailable", "false");
      let d = s.dataset.customLabel ?? window.variantStrings.addToCart;
      r && (r.textContent = d), n && n.classList.remove("hidden"), h && l.dataset.label && (h.textContent = l.dataset.label), c && c.classList.remove("hidden"), s.dataset.requiredFields === s.dataset.validFields && (s.removeAttribute("disabled"), a.forEach($ => {
        $.removeAttribute("disabled");
      }));
    }
    if (!x) return;
  }
  ["setUnavailable"]() {
    let t = document.getElementById("product-form-" + this.dataset.section);
    if (!t) return;
    let x = t.querySelector("[name=\"add\"]");
    var e = t.querySelector(".main-atc__label__text");
    e || (e = t.querySelector(".main-atc__label"));
    let i = document.getElementById("price-" + this.dataset.section),
      s = document.getElementById("Inventory-" + this.dataset.section),
      a = document.getElementById("Sku-" + this.dataset.section);
    x && (e && (e.textContent = window.variantStrings.unavailable), i && i.classList.add("visibility-hidden"), s && s.classList.add("visibility-hidden"), a && a.classList.add("visibility-hidden"));
  }
  ["getVariantData"]() {
    return this.variantData = this.variantData || JSON.parse(this.querySelector("[type=\"application/json\"]").textContent), this.variantData;
  }
  ["updateQuantityBreaksPickerPrices"]($, t, x) {
    if (!this.hasQuantityBreaksPicker) return;
    let i = this.querySelectorAll(".quantity-break");
    i.length && i.forEach(i => {
      if (!i.dataset.basePrice) return;
      let a = parseInt(i.dataset.basePrice),
        r = parseInt(i.dataset.baseComparePrice) || a,
        n = a;
      $ && t && ($ === "fixed_amount" ? n = Math.max(0, a - t) : "percentage" === $ ? n = Math.round(a * (100 - t) / 100) : "price" === $ && (n = t));
      let l = r - n,
        h = r > 0 ? Math.round(l / r * 100) : 0,
        c = formatMoney(n, x, !0),
        d = formatMoney(r, x, !0),
        o = formatMoney(l, x, !0),
        f = formatMoney(100 * Math.round(l / 100), x, !0),
        u = i.querySelectorAll(".variant-price-update[data-text]");
      u.forEach($ => {
        let x = $.dataset.text;
        x = (x = (x = (x = (x = x.replace("[price]", c)).replace("[compare_price]", d)).replace("[amount_saved]", o)).replace("[amount_saved_rounded]", f)).replace("[percentage_saved]", h + "%"), window.GiftsboxlySecurity.writeHTML($, x, false);
      });
      let b = i.querySelector(".quantity-break__compare-price");
      b && (r > n ? b.classList.remove("hidden") : b.classList.add("hidden"));
    });
  }
}
customElements.define("variant-selects", VariantSelects);
class SecondaryVariantSelect extends VariantSelects {
  constructor() {
    super(), this.secondarySelectSelector = "variant-selects-", this.secondarySelect = document.getElementById("" + this.secondarySelectSelector + this.dataset.section), this.isSecondary = !0;
  }
  ["updateOptions"]() {
    this.options = this.querySelector("select").value.split(",");
  }
}
customElements.define("secondary-variant-select", SecondaryVariantSelect);
class SecondaryVariantSelectSeparate extends VariantSelects {
  constructor() {
    super(), this.secondarySelectSelector = "variant-selects-", this.secondarySelect = document.getElementById("" + this.secondarySelectSelector + this.dataset.section), this.isSecondary = !0;
  }
}
customElements.define("secondary-variant-select-separate", SecondaryVariantSelectSeparate);
class CardVariantSelects extends VariantSelects {
  constructor() {
    super(), this.quickAddSubmit = document.getElementById(this.dataset.section + "-submit");
  }
  ["onVariantChange"]() {
    this.updateOptions(), this.updateMasterId(), this.toggleAddButton(!0, "", !1), this.updateVariantStatuses(), this.currentVariant ? (this.updateMedia(), this.updateVariantInput(), this.updateQuickAddUrl(), this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut)) : (this.toggleAddButton(!0, "", !0), this.setUnavailable());
  }
  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;
    let t = document.getElementById(this.dataset.section + "-image");
    if (!t) return;
    let x = this.currentVariant.featured_media.preview_image,
      e = x.src.split("?")[0],
      i = [165, 360, 533, 720, 940, 1066].filter($ => x.width >= $).map($ => e + "?width=" + $ + " " + $ + "w").join(", ");
    window.GiftsboxlySecurity.setResource(t, "srcset", i + ", " + e + " " + x.width + "w"), window.GiftsboxlySecurity.setResource(t, "src", e + "?width=533");
  }
  updateQuickAddUrl() {
    this.currentVariant && this.quickAddSubmit && (this.quickAddSubmit.dataset.productUrl = this.dataset.url + "?variant=" + this.currentVariant.id);
  }
}
customElements.define("card-variant-selects", CardVariantSelects);
